/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import React, { Component, createRef, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Col, Container, Row, Input, Modal, ModalHeader, Alert, ModalBody } from 'reactstrap';
import ConfigModal from '../../../components/EpikBoxes/EpikBoxDetails/ConfigModal';
import UnAssignedObiModal from '../../../components/EpikBoxes/EpikBoxDetails/UnAssignedObiModal';
import * as BoxesActions from '../../../actions/EpikBoxes';
import { addStep, popStep } from '../../../actions/Breadcrumbs';
import { masterBoxPressCall } from '../../../actions/Users';
import { updateNumberRoute } from '../../../actions/Provisioning';
import AddPhone from '../../../components/AddPhone';
import UpdateEpikBoxModal from '../../../components/EpikBoxes/UpdateEpikBoxModal';
import EditPhoneNumber from '../../../components/AddPhoneNumber';
import BoxOverview from '../../../components/EpikBoxes/BoxOverview';
import Breadcrumbs from '../../../components/Breadcrumb';
import AddNotesList from '../../../components/AddNotesList';
import LogsModal from '../../../components/EpikBoxes/EpikBoxDetails/LogsModal';
import DeleteBoxPhoneModal from '../../../components/DeleteBoxEpiModal';
import SelectedPortPanel from '../../../components/EpikBoxes/EpikBoxDetails/SelectedPortPanel';
import WithUserData from '../../../HOC/withUserData';
import Spinner from '../../../components/Spinner/Spinner';
import AddSecurityCodeModal from '../../../components/AddSecurityCodeModal';
import ConfirmationModal from '../../../components/ConfirmationModal';
import CdrAnalyticsModal from '../../../components/CdrAnalyticsModal';
import InfoToolTab from '../../../components/EpikBoxes/EpikBoxDetails/InfoToolTab';
import getObiData from '../helpers';
import getAtaData from '../helperAta';
import RebootEPINotification from '../../../components/EpikBoxes/RebootEPINotification';
import BoxPortingDetails from '../../../components/EpikBoxes/EpikBoxDetails/BoxPortingDetails';
import CustomSelection from '../../../components/CustomSelection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EdgeDeviceLocator from '../../../components/EpikBoxes/EpikBoxDetails/EdgeDeviceLocator/boxMap';
import UpdateBoxLocation from '../../../components/EpikBoxes/EpikBoxDetails/EdgeDeviceLocator/boxUpdate';
import { isAdminRole, isEscene } from '../../../lib/utils';
import PingModal from '../../../components/PingModal';
import {
  addNumber,
  addNumberFieldChange,
  getForwardUri,
  updateNumber,
  updateObiByNumber,
  updateAtaByNumber,
  updateAtaByPortId,
  getNumbers as getCompanyNumbers,
  getObiCallerOverRide
} from '../../../actions/Numbers';
import {
  addAction,
  changeAction,
  changeBulkBoxSession,
  deleteAction,
  enableAction,
  resetBulkBoxSession,
  sendBulkActionsToApi,
  unassignAction,
  disableAction,
} from '../../../actions/BoxSessionLogging';
import download from '../../../Res/Icon/download.png';
import notesIcon from '../../../Res/Icon/notes.png';
import logIcon from '../../../Res/Icon/logImg.png';
import analyticsIcon from '../../../Res/Icon/Analytics-Icon.png';
import './epikBoxDetails.css';
import '../BoxList/epikBoxes.css';
import SpinnerCircles from '../../../components/Spinner/SpinerCircles';
import moment from 'moment';
import SelectedAtaPanel from '../../../components/EpikBoxes/EpikBoxDetails/SelectedAtaPanel';
import { delay } from 'lodash';
import CustomWarning from '../../../components/CustomWarning';
import CustomModal from '../../../components/CustomModal';
import utils from '../../../lib/utils';
import { arrayType, dialToneOnly } from '../../../components/EpikBoxes/constants';
import { addSystemLogs } from '../../../actions/SystemLogs';
import { getPriBoxesByCompany, getSipBoxesByCompany } from '../../../actions/Companies';
import ActivateButton from './components/ActivateButton';
import BoxHeader from './components/BoxHeader';
import addBoxAction from '../../../lib/api/addBoxAction';
import AdminFlagsDropDown from './components/AdminFlagsDropDown';
import addDeviceActivityNote from '../../../lib/api/addNote';
import { getPermissionForComponent } from '../../../utils/permissionsUtils';
import { esceneFromObiValues } from '../../../utils/constants';
import {NUMBER_TYPES_LABEL} from '../../../lib/constants'
const url = require('url');

const filterOptions = ['no', 'yes'];

const isFalsy = (value) => {
  return (
    value === '' ||
    value === null ||
    value === undefined ||
    value === false ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
  );
};


const generateObiChangeLogs= (matchingObis, targetNumber)=>{
  const logs = [];
  const portNames = Object.keys(matchingObis)
  .map(port => {
    const match = port.match(/^port(\d+)$/);
    if (match) {
      return `Port ${match[1]}`;
    }
    return port;
  })
  .join(', ');
logs.push(`Changes made at OBI at ${portNames} are: callerIdOverride updated from ${targetNumber} to null`);
  return logs;
}
class EpikBoxDetails extends Component {
  constructor(props) {
    super(props);
    this.configUploadRef = createRef();
    this.token = localStorage.getItem('jwtToken') || null;

    this.state = {
      noActivation: moment(props?.boxDetails?.creationDate).isBefore(
        moment(process.env.REACT_APP_PORT_PROVISIONED_STARTED_AT, 'MM-DD-YYYY').toDate(),
      ),
      isLoading: false,
      confSelectedObi: null,
      alerEngineerLock: false,
      engineeringLockChecked: false,
      showBox: true,
      phoneFormData: null,
      boxDisplayName: '',
      masterPressStatus: false,
      priStatus: true,
      showNotes: false,
      enableBoxEdit: true,
      logModalStatus: false,
      fwdv2: false,
      modalStatus: false,
      toggleCheck: false,
      confirmModalStatus: false,
      warningStatus: '',
      speedTestInfo: null,
      speedDataInfo: null,
      importList: [],
      portMode: 'ports',
      lockWarning: props.user?.lockReminder || false,
      initialStatus: false,
      time: { h: 0, m: 0, s: 0 },
      seconds: 0,
      tempModal: false,
      tempValue: 'no',
      controlExecuteBtn: true,
      cdrAnalytics: false,
      boxCdrs: [],
      isActivityRowSelected: false,
      boxActivityLogs: null,
      displayEdgeDeviceLocator: false,
      updateEdgeDeviceLocator: false,
      edgeDeviceGeoCoordinates: null,
      updateEstematedAddress: null,
      partialWarning: false,
      addNewEpi: false,
      newMacAddress: null,
      portCount: { registeredPorts: 0, totalPorts: 0 },
      isBoxOnline: { loading: true, value: true },
      // epiFwUpdate: false,
      integrateModalSecure: false,
      isModalOpen: false,
      fetchPingData: [],
      pingType: null,
    };
    this.inputRef = React.createRef();
    this.phoneObj = null;
    this.saveNumber = false;
    this.timer = 0;
    this.editRouteReq = {
      token: null,
    };
    this.setState({
      portMode: props.user.company.companyType !== 'manufacturer' ? 'ports' : 'phones',
    });
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));
    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    let obj = {
      h: hours,
      m: minutes,
      s: seconds,
    };
    return obj;
  }

  pingDevices = async (type) => {
    this.setState({
      pingType: type
    });
    await this.getBoxIntiatePing(type);

  };
  pingDevicesFetchResult = async (type) => {
    this.setState({
      pingType: type,
      isModalOpen: true,
    });
    await this.pingRequest(type);

  };

  startTimer() {
    if (this.timer == 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    if (seconds == 0) {
      clearInterval(this.timer);
    }
  }

  pingRequest = async (pingType) => {
    const {
      getEpikBoxData,
      getFetchPingResult,
    } = this.props;
    const boxId = window.location.pathname.split('/').pop();

    if (boxId) {
      let type = pingType;
      const boxData = await getEpikBoxData(this.token, boxId, type);
      const result = await getFetchPingResult(this.token, boxData.vpnAddress, type);
      if (result) {
        this.setState({
          pingType: pingType,
          fetchPingData: result.Response
        });
      } else {
        this.setState({
          isModalOpen: false,
        });
      }
    }
  };
  handlePingClose = () => {
    this.setState({
      isModalOpen: false,
      fetchPingData: []

    });

  };

  getBoxIntiatePing = async (pingType) => {
    const {
      getEpikBoxData,
      getInitiatePing,
    } = this.props;
    const boxId = window.location.pathname.split('/').pop();

    if (boxId) {
      let type = pingType;
      const boxData = await getEpikBoxData(this.token, boxId, type);
      await getInitiatePing(this.token, boxData.vpnAddress, type);

    }
  };

  getIsBoxOnline = async (vpnAddress, boxID) => {
    const result = await this.props.getIsBoxOnline(this.token, vpnAddress);
    this.setState({ isBoxOnline: {loading:false, value: result && result.success || false} })
  }

  componentDidMount = async () => {
    const { setBoxDetailsData, user, getPriBoxesByCompany, boxDetails } = this.props;
    this.setState({ isLoading: true });
    const boxId = window.location.pathname.split('/').pop();
    await Promise.all([setBoxDetailsData(this.token, { _id: boxId }), this.lockStatus(boxId)])
    await this.props.getRestStatus(this.token, boxId)
    this.setState({ isLoading: false, initialStatus: true })
    this.onBoxLoad()
    const cancelIntegrationAccessPermission = getPermissionForComponent('cancelIntegrationAccess',user.permissionsGroup);
    this.setState({ cancelIntegrationAccess: cancelIntegrationAccessPermission })
  };

  componentDidUpdate(prevProps) {
    const { boxCdrActivity, boxDetails, engineeringLock, getAdminFlags } = this.props;
    const { engineeringLockChecked } = this.state;
    this.recentBoxes(boxDetails);
    if (boxDetails?.creationDate !== prevProps?.boxDetails?.creationDate) {
      this.setState({
        noActivation: moment(boxDetails.creationDate).isBefore(
          moment(process.env.REACT_APP_PORT_PROVISIONED_STARTED_AT, 'MM-DD-YYYY').toDate(),
        ),
      });
    }
    if (boxCdrActivity && prevProps.boxCdrActivity !== boxCdrActivity) {
      this.setState({
        isActivityRowSelected: true,
        boxActivityLogs: boxCdrActivity,
      });
    }

    if(!engineeringLockChecked && prevProps?.engineeringLock !== engineeringLock) {
      if(engineeringLock && engineeringLock['box'] ===  boxDetails?._id){                             
        this.setState({  engineeringLockChecked: true, alerEngineerLock: engineeringLock })
      }  
    }

    if (prevProps?.boxDetails?._id !== boxDetails?._id) {
      this.alarmTimerCheck(boxDetails);
      getAdminFlags(this.token, boxDetails?._id)
    }

    if (prevProps?.boxDetails?.slaveBoxes?.length !== boxDetails?.slaveBoxes?.length) {
      if (boxDetails?.masterBox === null) {
        if (boxDetails?.slaveBoxes.length > 0) {
          this.setState({ slaveType: 'Primary' });
        } else {
          this.setState({ slaveType: '' });
        }
      } else {
        this.setState({ slaveType: 'Secondary' });
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.interval = undefined;
  }

  lockStatus = async (boxId) => {
    const { boxLockStatus } = this.props;
    const bid = boxId || window.location.pathname.split('/').pop();
    const data = await boxLockStatus(this.token, bid);
    clearInterval(this.timer);
    this.setState({ seconds: data?.timeRemaining || 1 }, () => {
      this.timer = 0;
      this.startTimer();
    });
  };

  speedBox = async () => {
    const { getLteAnalyzer, boxDetails } = this.props;
    await getLteAnalyzer(this.token, boxDetails._id, boxDetails.vpnAddress);
    await this.getBoxData();
  };

  getCompNumbers = async companyId => {
    const { getCompanyNumbers } = this.props;
    await getCompanyNumbers(this.token, true, companyId, 'all', true);
  };

  systemStatus = async () => {
    const { getSystemStatus } = this.props;
    const boxId = window.location.pathname.split('/').pop();
    await getSystemStatus(this.token, boxId);
  };

  // commenting this code intentionally

  // initialBox = async () => {
  //   const { cancelRearrangeEPIs } = this.props;
  //   if (!this.interval && window.location.pathname.split('/').length === 3) {
  //     this.interval = setInterval(this.getBoxData, 100000);
  //   }
  //   if (this.inputRef && this.inputRef.current) {
  //     this.inputRef.current.focus();
  //   }
  //   cancelRearrangeEPIs();
  // };

  recentBoxes = box => {
    if (box?._id) {
      const recentBoxesList = localStorage.getItem('recentBoxes') || '[]';
      const recentBoxes = JSON.parse(recentBoxesList);

      if (
        !recentBoxes.find(item => {
          const backToUTF8 = JSON.parse(Buffer.from(item, 'base64').toString('utf8'));
          return backToUTF8?._id === box?._id;
        })
      ) {
        if (recentBoxes.length < 5) {
          const recentBoxesArray = recentBoxes || [];
          const objectToBase64 = Buffer.from(JSON.stringify(box), 'utf8').toString('base64');
          recentBoxesArray.push(objectToBase64);
          localStorage.setItem('recentBoxes', JSON.stringify(recentBoxesArray));
        } else {
          const recentBoxesArray = recentBoxes || [];
          const objectToBase64 = Buffer.from(JSON.stringify(box), 'utf8').toString('base64');
          recentBoxesArray.unshift(objectToBase64);
          recentBoxesArray.pop();
          localStorage.setItem('recentBoxes', JSON.stringify(recentBoxesArray));
        }
      }
    }
  };

  getBoxData = async () => {
    const {
      getEpikBoxData,
      getBoxPower,
      getEpikBoxesData,
      boxDetails,
      popStep,
      addStep,
      user,
      getSignalStrength,
    } = this.props;
    const { masterPressStatus, boxDisplayName } = this.state;
    const urlObj = url.parse(document.location.href, true);
    const companyId = urlObj?.query?.company;
    const boxId = window.location.pathname.split('/').pop();
    global.boxDetailStatus = true;
    this.companyId = companyId;
    if (boxId) {
      const { getEngineeringLock, getAdminFlags } = this.props;
      getEngineeringLock(this.token, boxId);
      getAdminFlags(this.token, boxId)
      const boxData = await getEpikBoxData(this.token, boxId);
      await getSignalStrength(this.token, boxId);
      this.getCompNumbers(boxData?.assignedTo?._id);
      // eslint-disable-next-line no-unused-expressions
      boxData?.myEpik ? (global.myEpik = 'Yes') : (global.myEpik = 'No');
      this.setState({
        advMonitoring: boxData?.advancedMonitoring,
        fwdv2: boxData?.myEpik,
        modalStatus: false,
        confirmModalStatus: false,
        boxDisplayName: boxData?.displayName,
      });
      if (user.role !== 'companyGroupAdmin') {
        await getEpikBoxesData(this.token, companyId, 'none');
      }
      if (boxDetails.masterBox !== null) {
        this.setState({
          masterBoxName: `${boxDetails?.masterBox?.serialNumber || '-'}/${boxDetails?.masterBox?.displayName
            }`,
        });
      }
      this.alarmTimerCheck(boxData);
      if (boxData?.masterBox === null) {
        if (boxData?.slaveBoxes.length > 0) {
          this.setState({ slaveType: 'Primary' });
        } else {
          this.setState({ slaveType: '' });
        }
      } else {
        this.setState({ slaveType: 'Secondary' });
      }
      if (masterPressStatus) {
        popStep();
        addStep({ label: boxDisplayName, redirect: '' });
      }

      this.setState({ isLoading: false });
    }
  };

  onBoxLoad = async () => {
    const {
      popStep,
      addStep,
      getDataOnBoxLoad,
      getEngineeringLock,
      getAdminFlags,
      boxDetails,
      getActiveInterface,
      checkNumberRouteAndTrunk,
      updateNumberRouteAndTrunk,
      getAssignedNumbers,
      getSipPri,
      getPriBoxesByCompany,
      getSipBoxesByCompany
    } = this.props;
    const { masterPressStatus, boxDisplayName } = this.state;
    const { user } = this.props;
    const boxID = window.location.pathname.split('/').pop();

    boxDetails?.myEpik ? (global.myEpik = 'Yes') : (global.myEpik = 'No');
    const timeLeftLock = this.secondsToTime(this.state.seconds);
    if (boxDetails && boxDetails.vpnAddress && !boxDetails?.serialNumber?.startsWith('E-')) {
      await this.getIsBoxOnline(boxDetails.vpnAddress, boxID);
    }
    getEngineeringLock(this.token, boxID);
    getAdminFlags(this.token, boxID)
    getAssignedNumbers(
      this.token,
      boxDetails?.assignedTo?._id,
      boxDetails?.epikBoxUser?._id,
      false,
    );

    if (!boxDetails.myEpik) {
      getSipPri(this.token, boxDetails?._id, true);
      getSipPri(this.token, boxDetails?._id, false);

      const esceneAta = boxDetails?.Obis?.some((item) =>
        item.macAddress.startsWith("0026")
      );

      const timer = utils.calculateEpiFirmwareUpdateTimer(boxDetails?.epiFirmwareUpdateTimer);
      const authorizedUser = ['companyGroupAdmin', 'superAdmin'].includes(user?.role);

      // if (boxDetails?.epiFwUpdateAvailable && timer && esceneAta && authorizedUser) this.setState({ epiFwUpdate: true });

    }

    if (boxDetails.masterBox !== null) {
      this.setState({
        masterBoxName: `${boxDetails?.masterBox?.serialNumber || '-'}/${boxDetails?.masterBox?.displayName
          }`,
      });
    }

    if (boxDetails?.masterBox === null) {
      if (boxDetails?.slaveBoxes.length > 0) {
        this.setState({ slaveType: 'Primary' });
      } else {
        this.setState({ slaveType: '' });
      }
    } else {
      this.setState({ slaveType: 'Secondary' });
    }

    if (masterPressStatus) {
      popStep();
      addStep({ label: boxDisplayName, redirect: '' });
    }

    if (!boxDetails.myEpik) {
      await updateNumberRouteAndTrunk(this.token, boxID);
      await checkNumberRouteAndTrunk(this.token, boxID)
    }
    console.log('prisettin features ', boxDetails.features)
    boxDetails?.features?.pri && await getSipPri(this.token, boxID, boxDetails?.features?.pri);
    if (boxDetails?.assignedTo?._id) {
      await getPriBoxesByCompany(this.token, boxDetails.assignedTo._id);
      await getSipBoxesByCompany(this.token, boxDetails.assignedTo._id);
    }
  }

  alarmTimerCheck = async box => {
    const { getAlarmTest, InitiateAlarm } = this.props;
    const timer = await getAlarmTest(this.token, box._id);
    await InitiateAlarm(timer?.remainingTime || 0);
  };


  onBoxContainerClick = () => {
    const { clearSelectedPort, clearSelectedObi } = this.props;
    clearSelectedPort();
    clearSelectedObi();
    this.onClearSelectedAta();
    setTimeout(() => {
      global.vmail = false;
    }, 2000);
  };

  onClearSelectedAta = () => {
    const { clearBoxDetailsAtaPort } = this.props;
    clearBoxDetailsAtaPort();
  };

  onUploadPortConfig = async (file, updatedPort) => {
    const { boxDetails, uploadPortConfig, selectPort, selectObi } = this.props;
    const box = boxDetails;
    const foundObi = box.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === updatedPort.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === updatedPort.boxPortNumber)
      );
    });
    selectObi(foundObi);
    if (foundObi) {
      if (foundObi.port1 && foundObi.port1.boxPortNumber === updatedPort.boxPortNumber) {
        foundObi.port1 = updatedPort;
      } else {
        foundObi.port2 = updatedPort;
      }
    }

    await uploadPortConfig(this.token, foundObi, file);
    await this.getBoxData();
    selectPort(updatedPort);
  };

  onPortUpdate = async (updatedPort, unassignNum) => {
    const {
      boxDetails,
      configurePort,
      unassignNumber,
      updateObi,
      editNumber,
      editedNumber,
      unassignAction,
      addNote,
      selectedPortConfigTemplate,
      selectedPort,
      changeAction,
      portConfigChangesMade: portConfigChangesMadeFromRedux,
    } = this.props;
    const { useDefaultPortConfig = true } = updatedPort;
    
    const portConfigChangesMade = portConfigChangesMadeFromRedux || false;

    // Find Port in box by boxPortNumber
    this.setState({ isLoading: true });
    const box = boxDetails;
    let foundObi = box.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === updatedPort.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === updatedPort.boxPortNumber)
      );
    });

    if (foundObi) {
      
      updatedPort.callerIdMasking = updatedPort?.assignedNumberRef?.callerIdMasking;
      updatedPort.callerIdMaskingNumber = updatedPort?.assignedNumberRef?.callerIdMaskingNumber;

      const previousAssignedNumber = foundObi.port1?.boxPortNumber === updatedPort.boxPortNumber 
      ? foundObi.port1.assignedNumber 
      : foundObi.port2.assignedNumber;

      if (updatedPort.assignedNumber && updatedPort.assignedNumber !== previousAssignedNumber) {
        updatedPort.monitored = true; 
      }
      if (foundObi.port1 && foundObi.port1.boxPortNumber === updatedPort.boxPortNumber) {
        foundObi.port1 = updatedPort;
        foundObi.changedPort = 'port1';
      } else {
        foundObi.port2 = updatedPort;
        foundObi.changedPort = 'port2';
      }
      foundObi.rebootRequired = boxDetails.inhouseProvision;
      const configurePortData = {
        boxId: foundObi._id,
        serviceName: updatedPort.serviceName,
        boxPortNumber: updatedPort.boxPortNumber,
      };
      await configurePort(this.token, configurePortData); //doing nothing 
      // update number type before unassigning number from obi
      if (unassignNum) {
        let  getData =await this.props.getObiCallerOverRide(this.token, boxDetails?._id ,editedNumber?.number,true);
        const resp = await unassignNumber(this.token, editedNumber.number, updatedPort.boxPortNumber);
        if (resp) {
          // [Action] - unassign
          const message = `Number ${editedNumber?.number} was removed from`;
          unassignAction(`${message} ${updatedPort?.boxPortNumber}`);
          const obj = {
            note: `${message} ${updatedPort?.boxPortNumber}`,
            type: 'system',
          };
          await addNote(this.token, boxDetails._id, obj);
          //add this logs for change in OBI
          if (getData && Object.keys(getData).length > 0) {
            const changes = await generateObiChangeLogs(getData, editedNumber?.number);
            await changeAction(`${changes.join('\n')}`);
          }
        }
      } else {
          if(updatedPort.serviceName == dialToneOnly && editedNumber.number){
            const resp = await unassignNumber(this.token, editedNumber.number, updatedPort.boxPortNumber);
          if (resp) {
            delete updatedPort.assignedNumberRef;
            delete updatedPort.assignedNumber;
            // [Action] - unassign
            const message = `Number ${editedNumber?.number} removed from`;
            unassignAction(`${message} ${updatedPort?.boxPortNumber}`);
            const obj = {
              note: `${message} ${updatedPort?.boxPortNumber}`,
              type: 'system',
            };
            await addNote(this.token, boxDetails._id, obj);
          }
        }
        // update port config values according to port config template
        const updatedPortNumber = foundObi.changedPort
        const portName = foundObi[updatedPortNumber]?.serviceName
        const configTemplates = this.props.portConfigTemplates;
        let portConfig = null
        const isEsceneDevice = isEscene(foundObi?.macAddress)
        if (selectedPortConfigTemplate && Object.keys(selectedPortConfigTemplate).length == 0) {
        // mean no custom template selected; apply default one according to ATA type
          let requiredTemplate = isEsceneDevice ? `${portName} Granite` : `${portName} Obi`
          console.log(" default template is going to apply: ", requiredTemplate)
          
          // Normalize template names for comparison (handle camelCase, "modem Hunt", "Modem Hunt", etc.)
          const normalizeTemplateName = (name) => {
            if (!name) return '';
            // Remove spaces and convert to lowercase for comparison
            return name.replace(/\s+/g, '').toLowerCase();
          };
          
          const normalizedRequiredTemplate = normalizeTemplateName(requiredTemplate);
          configTemplates.map((el) => {
            const normalizedTitle = normalizeTemplateName(el.title);
            if (normalizedTitle === normalizedRequiredTemplate) {
              portConfig = { ...el }
              return;
            }
          })
        }

        if (selectedPortConfigTemplate && Object.keys(selectedPortConfigTemplate).length && selectedPort.serviceName === portName && !portConfigChangesMade) {
          portConfig = { ...selectedPortConfigTemplate }
        }

        if (portConfigChangesMade) {
          portConfig = { _id: selectedPortConfigTemplate?._id }
        }

        if (portConfig) {
          const tempId = portConfig._id

          delete portConfig.title
          delete portConfig.__v;
          delete portConfig._id
          delete portConfig.name;

          if(isEsceneDevice && !Object.values(esceneFromObiValues).includes(portConfig.RingVoltage))
          {
            portConfig={...portConfig, RingVoltage: esceneFromObiValues[portConfig.RingVoltage]}
          }
          // added fix to not update port config if template is same. also fixes the cache issue
          let tempPortConfig = {}
          if(useDefaultPortConfig && tempId != foundObi[updatedPortNumber]?.appliedConfigTemplate?._id /*old id of template */) {
            tempPortConfig = { ...portConfig };
            tempPortConfig.appliedConfigTemplate = tempId;
            tempPortConfig.configOverride = !!tempId;
          } else if(useDefaultPortConfig === false) {
            tempPortConfig.appliedConfigTemplate = tempId;
          }
          // console.info({changed:foundObi.changedPort,useDefaultPortConfig,tempPortConfig,tempId,foundObi:foundObi[updatedPortNumber]?.appliedConfigTemplate})
          foundObi = {
            ...foundObi,
            [foundObi.changedPort]: {
              ...foundObi[foundObi.changedPort],
              ...tempPortConfig
            }
          }

        }

        await updateObi(
          this.token,
          foundObi,
          box.epikBoxUser._id,
          (updatedPort.assignedNumberRef && updatedPort.assignedNumberRef._id) ||
          updatedPort.assignedNumberRef,
        );

        const keys = [
          'blockCallerId',
          'advancedModemConfiguration',
          'callerIdMasking',
          'callerIdMaskingNumber',
          'callerIdOverride',
          'appliedConfigTemplate'
        ];

        const updatedFields = [];
  
        const normalizeValue = (value) => {
          if (Array.isArray(value)) {
            return JSON.stringify(value.map((item) => (item._id ? item._id.toString() : item)).sort());
          }
          if (value && typeof value === 'object' && value._id) {
            return value._id.toString();
          }
          return value?.toString() || value;
        };
        
        keys.forEach((key) => {
          const originalValue = updatedPort[key];
          const newValue = selectedPort[key];

          if (isFalsy(originalValue) && isFalsy(newValue)) {
            return;
          }
        
          const normalizedOriginal = normalizeValue(originalValue);
          const normalizedNew = normalizeValue(newValue);
        
          if (normalizedOriginal !== normalizedNew) {
            updatedFields.push({
              field: key,
              newValue: normalizedOriginal || 'null',
              oldValue: normalizedNew || 'null',
            });
          }
        });

        if (updatedFields.length > 0) {
          const notes = updatedFields
            // .map(
            //   ({ field, oldValue, newValue }) =>
            //     `<li>"${field}" updated from "${oldValue}" to "${newValue}".</li>`
            // )
            // .join('');
            // .map(({ field, oldValue, newValue }) => {
            //   if (newValue == null) {
            //     return `<li>"${field}" updated from null to "${oldValue}".</li>`;
            //   } else {
            //     return `<li>"${field}" updated from "${oldValue}" to "${newValue}".</li>`;
            //   }
            // })
            .map(({ field, oldValue, newValue }) => {
              if (oldValue == null) {
                return `<li>"${field}" updated from null to "${newValue}".</li>`;
              } else {
                return `<li>"${field}" updated from "${oldValue}" to "${newValue}".</li>`;
              }
            })
            .join('');
        
          await changeAction(`Changes made to the OBI at ${updatedPort?.boxPortNumber} are:<ul>${notes}</ul>`);
        }
      }
      
      // Clear port config changes made flag in Redux after Save is completed
      if (portConfigChangesMade && this.props.clearPortConfigChangesMade) {
        this.props.clearPortConfigChangesMade();
      }
      
      // Clear port config modal source in Redux after Save is completed
      if (this.props.clearPortConfigModalSource) {
        this.props.clearPortConfigModalSource();
      }
      
      this.setState({ isLoading: false });
      await this.getBoxData();
    }
  };
  updateNumbersData = async (updatedPort, fieldToUpdate, value) => {
    const {
      boxDetails,
      updateNumbers,
    } = this.props;
    // Find Port in box by boxPortNumber
    this.setState({ isLoading: true });
    const box = boxDetails;
    const foundObi = box.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === updatedPort.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === updatedPort.boxPortNumber)
      );
    });

    if (foundObi) {
      if (foundObi.port1 && foundObi.port1.boxPortNumber === updatedPort.boxPortNumber) {
        foundObi.port1 = updatedPort;
        foundObi.changedPort = 'port1';
      } else {
        foundObi.port2 = updatedPort;
        foundObi.changedPort = 'port2';
      }
      const showToast = (fieldToUpdate === 'portLabel') || false;
      await updateNumbers(
          this.token,
          foundObi,
          box.epikBoxUser._id,
          (updatedPort.assignedNumberRef && updatedPort.assignedNumberRef._id) ||
          updatedPort.assignedNumberRef,
          fieldToUpdate,
          value,
          showToast
      );
      
      this.setState({ isLoading: false });
      // await this.getBoxData();
    }
  };

  getObiNumber = portName => {
    const { boxDetails } = this.props;
    const portSelected = portName.split(' ');
    const obiIndex = Math.round((parseInt(portSelected[1]) + 0.5) / 2);
    const { obiNumber } = boxDetails.Obis[obiIndex - 1];
    return obiNumber;
  };

  saveEditedNumber = async obiNumber => {
    const {
      selectedPort,
      getForwardUri,
      updateObiByNumber,
      updateNumberRoute,
      editNumber,
      editedNumber,
      boxDetails,
      enableAction,
      selectPort,
      editModifyStatus,
      addAction,
      numberByID,
      updateBox,
      selectedModalPortType,
      routeInfo,
      changeAction
    } = this.props;
    const changedNumber = {
      ...editedNumber,
      linkedBox: boxDetails._id,
      alarmRelayInfo: numberByID?.alarmRelayInfo,
    };
    const reg = !boxDetails.myEpik
      ? /{sip_h_X-Epik-Call-Type=fax,sip_h_X-Epik-Uri=user\/port[0-9]}\user\/.*/m
      : /user\/.*\.[1-9]/m;

    if (changedNumber.huntPorts) {
      changedNumber.huntPorts = Array.from(new Set(changedNumber.huntPorts));
    }
    if (changedNumber.forwardUris && changedNumber.forwardUris.length === 0 && changedNumber.type !== 'ringDown') {
      const forwardUris = await getForwardUri(
        this.token,
        obiNumber,
        selectedPort.boxPortNumber.toLowerCase(),
        'forwardUri',
      );
      changedNumber.forwardUris = [...changedNumber.forwardUris, forwardUris];
    }
    if (!changedNumber.assignedTo) {
      delete changedNumber.assignedTo;
    }
    if (changedNumber.cid === '') {
      delete changedNumber.cid;
    }
    delete changedNumber.dateCreated;
    delete changedNumber.companyID;
    delete changedNumber.companyName;
    const checkPort = selectedPort.boxPortNumber.toLowerCase();
    changedNumber.port = checkPort;
    if (
      !this.isVmail &&
      this.isVmail !== 'vmailType' &&
      reg.test(
        changedNumber.forwardUris &&
        changedNumber.forwardUris.length &&
        changedNumber.forwardUris[0],
      )
    ) {
      const res = await updateObiByNumber(this.token, obiNumber, {
        number: changedNumber.number,
        // assignedNumberRef: changedNumber._id || '',
        port: changedNumber.port,
        type: changedNumber.type,
        assignedNumberRef: changedNumber._id,
        rebootRequired: boxDetails.inhouseProvision,
      });
      if (res) {
        sendBulkActionsToApi();
      }
    }
    if (this.editRouteStatus && this.editRouteReq.token !== null) {
      await updateNumberRoute(
        this.editRouteReq.token,
        this.editRouteReq.id,
        this.editRouteReq.body,
      );
    }
    if (changedNumber.type === 'dialout') {
      if (changedNumber.spoofIncomingCid) {
        const val = changedNumber.cidOverride.substring(
          changedNumber.cidOverride.length - parseInt(changedNumber.numDigits),
        );
        if (changedNumber.spoofType === 'prepend') {
          changedNumber.cidOverride = `${val}[callingNum]`;
        }
        if (changedNumber.spoofType === 'append') {
          changedNumber.cidOverride = `[callingNum]${val}`;
        }
      }
    }

    if (!changedNumber?.number) return false;

    const carrierMapping = {
      voicetel: 'routeInfo',
      inteliquent: 'trunk',
      tdm: 'tdmRoute'
    };
    
    // if (changedNumber?.carrier && carrierMapping[changedNumber.carrier]) {
    //   changedNumber[carrierMapping[changedNumber.carrier]] = routeInfo;
    // }

    if(editedNumber?.trunk && changedNumber?.carrier && changedNumber?.carrier === 'inteliquent') {
      changedNumber['trunk'] = editedNumber?.trunk;
    }

    if(editedNumber?.routeInfo?.route && changedNumber?.carrier && changedNumber?.carrier === 'voicetel') {
      changedNumber['routeInfo'] = editedNumber?.routeInfo;
    }

    const res = await editNumber(this.token, changedNumber);
    if (res) {
      selectPort({
        ...selectedPort,
        assignedNumberRef: changedNumber,
        serviceName: changedNumber.type,
      });

      const keys = [
        'type',
        'portLabel',
        'huntType',
        'huntPorts',
        'modemType',
        'carrier',
        'callerIdName',
        'allowedUsers',
        'inBoundCallBlocked',
        'inbandRouting',
        'allowedNumbers',
        'forwardNumbers',
        'cidOverride',
        'spoofIncomingCid',
        'spoofType',
        'numDigits',
        'emails',
        'fallbackEmails',
        'savefaxes',
        'faxDeliveryConfirmation',
        'confirmationEmail'
      ];
      
      const selectedNumber = selectedPort?.assignedNumberRef || {};
      const updatedFields = [];
      
      const normalizeValue = (value) => {
        if (Array.isArray(value)) {
          return JSON.stringify(value.map((item) => (item._id ? item._id.toString() : item)).sort());
        }
        if (value && typeof value === 'object' && value._id) {
          return value._id.toString();
        }
        return value?.toString() || value;
      };

      keys.forEach((key) => {
        const originalValue = selectedNumber[key];
        const newValue = editedNumber[key];

        if (isFalsy(originalValue) && isFalsy(newValue)) {
          return;
        }
  
        const normalizedOriginal = normalizeValue(originalValue);
        const normalizedNew = normalizeValue(newValue);

        if (normalizedOriginal !== normalizedNew) {
        
          updatedFields.push({
            field: key,
            oldValue: normalizedOriginal || 'null',
            newValue: normalizedNew || 'null',
          });
        }
      });
      
      if (updatedFields.length > 0) {
        const notes = updatedFields
            .map(
              ({ field, oldValue, newValue }) =>
                `<li>"${field}" updated from "${oldValue}" to "${newValue}".</li>`
            )
            .join('');
        
          await changeAction(`Changes made to the number ${changedNumber?.number} at ${selectedPort?.boxPortNumber} are:<ul>${notes}</ul>`);
      }

      if (
        selectedModalPortType === 'add-new' &&
        (changedNumber.type === 'fax' || changedNumber.type === 'faxStandard') &&
        !boxDetails.enhancedFax
      ) {
        const res = await updateBox(this.token, {
          ...boxDetails,
          enhancedFax: true,
        });
        if (res) {
          // [Action] - Change
          changeAction('changed Enhanced Fax');
        }
      }
      if (selectedPort?.assignedNumberRef?.type !== editedNumber?.type) {
        const { assignedNumberRef } = selectedPort 
        const capitalizedPort = assignedNumberRef?.port
          ? assignedNumberRef?.port[0].toUpperCase() + assignedNumberRef?.port.slice(1)
          : '';
        const assignedTypeLabel = NUMBER_TYPES_LABEL[assignedNumberRef?.type] || assignedNumberRef?.type || 'Unassigned';
        const changedTypeLabel = NUMBER_TYPES_LABEL[changedNumber?.type] || changedNumber?.type || '-';
        addBoxAction({ boxID: boxDetails?._id, activity: 'changed Line Type' });
        addDeviceActivityNote({ boxID: boxDetails?._id, note: `${capitalizedPort} Line type of ${changedNumber?.number} is changed from ${assignedTypeLabel} to ${changedTypeLabel}` });
      }
    }
    if (res && this.isVmail && this.isVmail !== 'vmailType') {
      // [Action] - enabled
      // port save modal
      this.onPortUpdate({
        ...selectedPort,
        serviceName: changedNumber.type,
        vmNumber: changedNumber.number,
      });
      enableAction(`VMail number ${changedNumber.number} added to port`);
    }
    if (!editModifyStatus) {
      addAction(`${changedNumber?.number} assigned to ${changedNumber?.port}`);
      addDeviceActivityNote({ boxID: boxDetails?._id, note: `Number ${changedNumber?.number} Assigned to ${changedNumber?.port}`});
    }
  };

  saveEditedAtaNumber = async obiNumber => {
    const {
      selectedPort,
      selectAta,
      getForwardUri,
      updateObiByNumber,
      updateAtaByPortId,
      updateNumberRoute,
      editNumber,
      editedNumber,
      boxDetails,
      enableAction,
      selectPort,
      editModifyStatus,
      addAction,
      selectExternalAta,
      updateAtaByNumber,
    } = this.props;
    const changedNumber = { ...editedNumber, linkedBox: boxDetails._id };
    const reg = !boxDetails.myEpik
      ? /{sip_h_X-Epik-Call-Type=fax,sip_h_X-Epik-Uri=user\/port[0-9]}\user\/.*/m
      : /user\/.*\.[1-9]/m;

    if (changedNumber.huntPorts) {
      changedNumber.huntPorts = Array.from(new Set(changedNumber.huntPorts));
    }

    if (changedNumber.forwardUris && changedNumber.forwardUris.length === 0) {
      const forwardUris = await getForwardUri(
        this.token,
        obiNumber,
        selectAta?.boxPortNumber?.toLowerCase(),
        'forwardUri',
        boxDetails?.externalAta[0]?._id,
      );
      changedNumber.forwardUris = [...changedNumber.forwardUris, forwardUris];
    }
    if (!changedNumber.assignedTo) {
      delete changedNumber.assignedTo;
    }
    if (changedNumber.cid === '') {
      delete changedNumber.cid;
    }
    delete changedNumber.dateCreated;
    delete changedNumber.companyID;
    delete changedNumber.companyName;
    const checkPort = selectAta?.boxPortNumber?.toLowerCase();
    changedNumber.port = checkPort;

    // if (
    //   // !this.isVmail &&
    //   // this.isVmail !== 'vmailType' &&
    //   reg.test(
    //     changedNumber.forwardUris &&
    //       changedNumber.forwardUris.length &&
    //       changedNumber.forwardUris[0],
    //   )
    // ) {
    const ataNumber = boxDetails.externalAta[0]._id;
    const responseAta = await updateAtaByNumber(this.token, ataNumber, {
      portID: selectAta?._id,
      type: changedNumber.type,
      assignedNumber: changedNumber._id,
    });
    if (responseAta) {
      sendBulkActionsToApi();
    }
    // }
    if (this.editRouteStatus && this.editRouteReq.token !== null) {
      await updateNumberRoute(
        this.editRouteReq.token,
        this.editRouteReq.id,
        this.editRouteReq.body,
      );
    }
    if (changedNumber.type === 'dialout') {
      if (changedNumber.spoofIncomingCid) {
        const val = changedNumber.cidOverride.substring(
          changedNumber.cidOverride.length - parseInt(changedNumber.numDigits),
        );
        if (changedNumber.spoofType === 'prepend') {
          changedNumber.cidOverride = `${val}[callingNum]`;
        }
        if (changedNumber.spoofType === 'append') {
          changedNumber.cidOverride = `[callingNum]${val}`;
        }
      }
    }
    const resp = await editNumber(this.token, changedNumber);
    if (resp) {
      selectExternalAta({
        ...selectAta,
        assignedNumberRef: changedNumber,
        serviceName: changedNumber.type,
      });
      if (this.isVmail !== 'vmailType') {
        const body = { portID: selectAta._id };
        const res = await updateAtaByPortId(
          this.token,
          boxDetails.externalAta[0]._id,
          body,
          boxDetails.epikBoxUser._id,
          changedNumber._id,
        );
        if (res) {
          sendBulkActionsToApi();
        }
        enableAction(`VMail number ${changedNumber.number} added to port`);
      } else {
        enableAction(`VMail number ${changedNumber.number} removed to port`);
      }

      await this.getBoxData();
    }

    if (!editModifyStatus) {
      addAction(`${changedNumber.number} assigned to ${changedNumber.port}`);
    }
  };

  removeAssignedAta = async () => {
    await this.getBoxData();
  };

  onAddNumber = async () => {
    const {
      user,
      addNewNumber,
      getAssignedNumbers,
      boxDetails,
      selectedPort,
      getForwardUri,
      updateObiByNumber,
    } = this.props;
    // eslint-disable-next-line react/destructuring-assignment
    const addedNumber = {
      ...this.props.addedNumber,
      carrier:
        process.env.REACT_APP_TEMP_NUMBER_CAREER_INTELIQUENT == 'true' ? 'inteliquent' : 'voicetel',
    };
    if (!addedNumber.assignedTo) {
      delete addedNumber.assignedTo;
    }

    if (addedNumber.type === 'dialout') {
      if (addedNumber.spoofIncomingCid) {
        const val = addedNumber.cidOverride.substring(
          addedNumber.cidOverride.length - parseInt(addedNumber.numDigits),
        );
        if (addedNumber.spoofType === 'prepend') {
          addedNumber.cidOverride = `${val}[callingNum]`;
        }
        if (addedNumber.spoofType === 'append') {
          addedNumber.cidOverride = `[callingNum]${val}`;
        }
      }
    }

    const portSelected = selectedPort?.boxPortNumber.split(' ');
    const obiIndex = Math.round((parseInt(portSelected[1]) + 0.5) / 2);
    const { obiNumber } = boxDetails.Obis[obiIndex - 1];
    const forwardUris = await getForwardUri(
      this.token,
      obiNumber,
      selectedPort.boxPortNumber.toLowerCase(),
      'forwardUri',
    );
    addedNumber.forwardUris = [...addedNumber.forwardUris, forwardUris];
    const res = await addNewNumber(this.token, user._id, addedNumber);
    if (res) {
      await getAssignedNumbers(
        this.token,
        boxDetails.assignedTo._id,
        boxDetails.epikBoxUser._id,
        false,
      );
      await updateObiByNumber(this.token, obiNumber, {
        number: addedNumber.number,
        port: addedNumber.port,
        type: addedNumber.type,
        assignedNumberRef: addedNumber._id,
        rebootRequired: boxDetails.inhouseProvision,
      });
    }

    this.saveNumToPort(res);
  };

  onAddAtaNumber = async () => {
    const {
      user,
      addNewNumber,
      getAssignedNumbers,
      boxDetails,
      selectedPort,
      selectAta,
      getForwardUri,
      updateObiByNumber,
      updateAtaByPortId,
    } = this.props;
    // eslint-disable-next-line react/destructuring-assignment
    const addedNumber = {
      ...this.props.addedNumber,
      carrier:
        process.env.REACT_APP_TEMP_NUMBER_CAREER_INTELIQUENT == 'true' ? 'inteliquent' : 'voicetel',
    };
    if (!addedNumber.assignedTo) {
      delete addedNumber.assignedTo;
    }

    if (addedNumber.type === 'dialout') {
      if (addedNumber.spoofIncomingCid) {
        const val = addedNumber.cidOverride.substring(
          addedNumber.cidOverride.length - parseInt(addedNumber.numDigits),
        );
        if (addedNumber.spoofType === 'prepend') {
          addedNumber.cidOverride = `${val}[callingNum]`;
        }
        if (addedNumber.spoofType === 'append') {
          addedNumber.cidOverride = `[callingNum]${val}`;
        }
      }
    }
    // const portSelected = selectedPort?.boxPortNumber.split(' ');
    // const obiIndex = Math.round((parseInt(portSelected[1]) + 0.5) / 2);
    const obiNumber = null;

    const forwardUris = await getForwardUri(
      this.token,
      obiNumber,
      selectAta?.boxPortNumber?.toLowerCase(),
      'forwardUri',
      boxDetails?.externalAta[0]?._id,
    );
    addedNumber.forwardUris = [...addedNumber.forwardUris, forwardUris];
    const res = await addNewNumber(this.token, user._id, addedNumber);
    if (res) {
      await getAssignedNumbers(
        this.token,
        boxDetails.assignedTo._id,
        boxDetails.epikBoxUser._id,
        false,
      );

      const body = { portID: selectAta._id };
      const updateResponse = await updateAtaByPortId(
        this.token,
        boxDetails.externalAta[0]._id,
        body,
        boxDetails.epikBoxUser._id,
        res._id,
      );
      await this.getBoxData();
      this.onBoxContainerClick();
    }
  };

  saveNumToAtaPort = res => {
    const { selectAta } = this.props;
    const updatedPortData = {
      ...selectAta,
    };
    updatedPortData.assignedNumberRef = res._id;
    updatedPortData.assignedNumber = res.number;
    // eslint-disable-next-line no-restricted-syntax
    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }
    this.updatedPort = '';
    this.onPortUpdate(updatedPortData);
    setTimeout(() => {
      this.onBoxContainerClick();
    }, 500);
  };

  saveNumToPort = res => {
    const { selectedPort } = this.props;
    const updatedPortData = {
      ...selectedPort,
    };
    updatedPortData.assignedNumberRef = res._id;
    updatedPortData.assignedNumber = res.number;
    // eslint-disable-next-line no-restricted-syntax
    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }
    this.updatedPort = '';
    this.onPortUpdate(updatedPortData);
    setTimeout(() => {
      this.onBoxContainerClick();
    }, 500);
  };

  toggelBox = () => {
    this.setState({ showBox: !this.state.showBox });
  };

  downloadConfig = () => {
    const { downloadOBIConfig } = this.props;
    const { confSelectedObi } = this.state;
    downloadOBIConfig(this.token, confSelectedObi);
  };

  jsonConfig = async jsonObj => {
    const { postOBIConfig, hideBoxConfig, obiRebootRequired, boxDetails } = this.props;
    const { confSelectedObi } = this.state;
    if (confSelectedObi) {
      const res = await postOBIConfig(this.token, confSelectedObi, jsonObj);
      if (res) {
        if (boxDetails.inhouseProvision) {
          await obiRebootRequired(this.token, confSelectedObi._id, {
            rebootRequired: true,
          });
        }
        hideBoxConfig();
      }
    } else {
      toast.error('Please select EPI');
    }
  };

  saveNumberFn = async vmail => {
    const { selectedPort, boxDetails } = this.props;
    this.isVmail = vmail;
    await this.saveEditedNumber(getObiData(selectedPort.boxPortNumber, boxDetails, 'obiNumber'));
  };

  saveNumberAtaFn = async vmail => {
    const { selectAta, boxDetails } = this.props;
    this.isVmail = vmail;
    await this.saveEditedAtaNumber(getAtaData(selectAta?.boxPortNumber, boxDetails, 'obiNumber'));
    this.setState({ isLoading: false }, () => {
      console.log('checking after SAVE state');
    });
  };

  updateRoute = (id, body, update) => {
    this.editRouteStatus = update;
    this.editRouteReq = {
      token: this.token,
      id,
      body,
    };
  };

  renderSelectedInfoModal = () => {
    const { selectedPort, selectedObi, boxDetails, selectAta } = this.props;
    if (!selectedPort && !selectedObi && !selectAta) {
      return <></>;
    }

    if (this.state.portMode === 'ports') {
      return selectedPort ? (
        <SelectedPortPanel
          updatePortConfig={this.getBoxData}
          myEpik={boxDetails.myEpik}
          updateNumberRoute={this.updateRoute}
          boxDetails={boxDetails}
          onAddNumber={this.onAddNumber}
          saveNumber={this.saveNumberFn}
          port={selectedPort}
          onPortUpdate={this.onPortUpdate}
          updateNumbersData={this.updateNumbersData}
          onUploadPortConfig={this.onUploadPortConfig}
          onOutsideClick={this.onBoxContainerClick}
          showPortDetail={this.state.portMode}
        />
      ) : (
        selectAta && (
          <SelectedAtaPanel
            updatePortConfig={this.getBoxData}
            myEpik={boxDetails.myEpik}
            updateNumberRoute={this.updateRoute}
            boxDetails={boxDetails}
            onAddNumber={this.onAddAtaNumber}
            saveNumber={this.saveNumberAtaFn}
            port={selectAta}
            onPortUpdate={this.onPortUpdate}
            onUploadPortConfig={this.onUploadPortConfig}
            onOutsideClick={this.onClearSelectedAta}
            showPortDetail={this.state.portMode}
            removeAssignedAta={this.removeAssignedAta}
          />
        )
      );
    }
  };

  onAssignObi = async obiId => {
    const { boxDetails, assignObi, addAction } = this.props;

    if (obiId.assignedTo) {
      const { serialNumber } = obiId.assignedTo;
      if (obiId.deleted) {
        toast.error(
          `EPI already assigned to Edge Device ${serialNumber.length > 0 ? serialNumber : obiId.assignedTo.displayName
          } which is deleted`,
        );
      } else {
        toast.error(
          `EPI already assigned to Edge Device ${serialNumber.length > 0 ? serialNumber : obiId.assignedTo.displayName
          }`,
        );
      }
    } else {
      const res = await assignObi(this.token, obiId._id, boxDetails._id, boxDetails.assignedTo);
      if (res) {
        addAction(`Assign ${obiId._id} EPI port`);
      }
      await this.getBoxData();
    }
  };

  boxTrigger = trigger => {
    if (trigger) {
      this.getBoxData();
    }
  };

  updateEpikFields = async (formData, paramType) => {
    const data = { ...formData };
    const {
      cancelUpdateEpikBox,
      updateBox,
      unCheckPri,
      sendBulkActionsToApi,
      boxDetails,
      disableAction,
      enableAction,
      addSystemLogs,
      user,
      suggectedCompany,
      getSipPri
    } = this.props;
    const { priStatus } = this.state;
    if (!data) {
      cancelUpdateEpikBox();
    } else {
      this.setState({ isOpen: false, isLoading: true });
      if (data.locRef && Object.keys(data.locRef).length === 0) {
        data.locRef = null;
      }
      const oldCompany =
        boxDetails?.assignedTo

      const newCompany = data?.assignedTo

      if (oldCompany?._id != (newCompany || newCompany?._id) && suggectedCompany?.bulkBoxSession.length > 0) {
        const body = {
          actionType: 'system',
          description: `${boxDetails?.displayName || 'Device'} with Serial Number ${boxDetails?.serialNumber} by ${user?.email} ${suggectedCompany?.bulkBoxSession[0]?.description}`,
        };
        await addSystemLogs(this.token, body)
      }

    const { priStatus } = this.state;
      const res = await updateBox(this.token, data);
      if (res) {
        // let serviceStatus = data.integratedChange ? ' is integrated ' : ' integration removed '
        let serviceStatus = data.integratedChange
          ? 'is integrated'
          : data.hasOwnProperty('integratedChange')
            ? 'integration removed'
            : 'updated';
        const body = {
          actionType: 'system',
          description: `${boxDetails?.displayName} with Serial Number ${boxDetails.serialNumber} ${serviceStatus} by ${user?.email} at ${utils.getDateTimeFormat(new Date())}`,
        };
        await addSystemLogs(this.token, body)

        if (paramType === 'saveBulk') {
          sendBulkActionsToApi();
        } else if (paramType) {
          if (boxDetails.monitor) {
            // [Action] - Disable
            disableAction(`Monitoring change from enable to disable`);
          } else {
            // [Action] - Enable
            enableAction(`Monitoring change from disable to enable`);
          }
        }
        //[Action]- Change
        changeAction('box updated');
        this.props.history.push(
          `/boxes/${data._id}?company=${data?.assignedTo?._id || data?.assignedTo}`,
        );
      }
      this.setState({ onOptionsStatus: false });
      if (!priStatus) {
        await unCheckPri(this.token, data._id);
        this.setState({ priStatus: true });
      }
      this.getBoxData();
      getSipPri(this.token, boxDetails?._id, true);
      getSipPri(this.token, boxDetails?._id, false);
    }
  };

  handleNumberModal = (e, number) => {
    const { showNumberModal } = this.props;
    this.updateNumberCall = false;
    this.phoneObj = { obj: e, numObj: number };
    showNumberModal();
  };

  insertPhone = e => {
    if (e.displayName && e.displayName !== '') {
      if (e.extension && e.extension !== '') {
        if (e.number && e.number !== '') {
          this.onEditNumber(e);
        } else {
          toast.error('Number required');
        }
      } else {
        toast.error('Extension required');
      }
    } else {
      toast.error('Display Name required');
    }
  };

  updatePhoneStatus = value => {
    this.updatePhone = value;
  };

  onEditNumber = async e => {
    const {
      boxDetails,
      editedNumber,
      updatePhone,
      insertPhone,
      hidePhoneModal,
      editNumber,
    } = this.props;
    const { phoneFormData } = this.state;
    const changedNumber = { ...editedNumber };
    const filterByCompany = boxDetails.assignedTo._id;
    if (!changedNumber.assignedTo) {
      delete changedNumber.assignedTo;
    }
    if (changedNumber.cid === '') {
      delete changedNumber.cid;
    }
    delete changedNumber.dateCreated;
    delete changedNumber.companyID;
    delete changedNumber.companyName;

    const token = localStorage.getItem('jwtToken') || null;
    if (!this.updateNumberCall || changedNumber.company === '') {
      let res;
      if (this.updatePhone) {
        res = await updatePhone(this.token, phoneFormData._id, e);
      } else {
        res = await insertPhone(this.token, boxDetails._id, e);
      }
      if (res) {
        this.getBoxData();
        hidePhoneModal();
      }
    } else {
      changedNumber.extension = e.extension;
      const res = await editNumber(token, changedNumber, null, filterByCompany, null);
      if (res) {
        this.props.sendBulkActionsToApi();
        let resPhone;
        if (this.updatePhone) {
          resPhone = await updatePhone(this.token, phoneFormData._id, e);
        } else {
          resPhone = await insertPhone(this.token, boxDetails._id, e);
        }
        if (resPhone) {
          this.getBoxData();
          hidePhoneModal();
        }
      }
    }
  };

  handlePhoneDelete = e => {
    const { showDeletePhone } = this.props;
    this.selectedPhone = e;
    showDeletePhone();
  };

  onDeleteBoxPhoneConfirm = async () => {
    const { deletePhone, cancelDeletePhone, deleteAction } = this.props;
    cancelDeletePhone();
    const res = await deletePhone(this.token, this.selectedPhone._id);
    if (res) {
      this.getBoxData();
      deleteAction(`Delete phone from box ${this.selectedPhone._id}`);
    }
  };

  boxLockEnable = async () => {
    const { boxDetails, boxLock } = this.props;
    await boxLock(this.token, boxDetails._id);
    await this.lockStatus();
    this.setState({ lockWarning: false });
  };

  onNotesPress = () => {
    const { boxDetails, getNotes } = this.props;
    this.setState({ showNotes: true });
    getNotes(this.token, boxDetails._id);
  };

  onLogsPress = async () => {
    const { boxDetails, getLogs } = this.props;
    await getLogs(this.token, boxDetails._id);
    this.setState({ logModalStatus: true });
  };

  onEditNote = async (e, noteId) => {
    const { editNote, boxDetails, getNotes } = this.props;
    const obj = new FormData();
    obj.append('attachment', JSON.stringify(e.attachment) || '');
    obj.append('createdAt', e.createdAt || '');
    obj.append('epikBox', e.epikBox || '');
    obj.append('file', e.file || '');
    obj.append('pinned', e.pinned || false);
    obj.append('note', e.note || '');
    obj.append('updatedAt', e.updatedAt || '');
    obj.append('user', JSON.stringify(e.user) || '');
    obj.append('_id', e._id || '');
    obj.append('isBoxTab', true);
    obj.append('boxId', boxDetails._id);

    const res = await editNote(this.token, boxDetails._id, obj, noteId);
    if (res) {
      getNotes(this.token, boxDetails._id, this.notesPagination);
    }
  };

  downloadAttachment = (id, name, noDownload) => {
    const { downloadAttachment } = this.props;
    return downloadAttachment(this.token, id, name, noDownload);
  };

  onDeleteNote = async note_id => {
    const res = await this.props.deleteNote(this.token, this.props.boxDetails._id, note_id);
    this.props.getNotes(this.token, this.props.boxDetails._id, this.notesPagination);
  };
  onDeleteNoteRecording = async note_id => {
    const { deleteNoteRecording, getNotes, boxDetails } = this.props;
    await deleteNoteRecording(this.token, note_id);
    await getNotes(this.token, boxDetails._id, this.notesPagination);
  };

  handleNotesPagination = async page => {
    const { getNotes, boxDetails } = this.props;
    this.notesPagination = { page, limit: 10 };
    getNotes(this.token, boxDetails._id, this.notesPagination);
  };

  addNotes = async e => {
    const { addNote, getNotes, boxDetails } = this.props;
    const obj = new FormData();
    obj.append('file', e.file || '');
    obj.append('note', e.note || '');
    obj.append('type', e.type || 'none');
    obj.append('isBoxTab', true);
    obj.append('boxId', boxDetails._id);

    const res = await addNote(this.token, boxDetails._id, obj);
    if (res) {
      getNotes(this.token, boxDetails._id);
    }
  };

  onActivateBox = async () => {
    const { activateEpikBox, updateBox, boxDetails, getEpikBoxData, boxToActivate } = this.props;
    this.setState({ isLoading: true });
    await activateEpikBox(this.token, boxDetails._id);
    if (boxToActivate) {
      const updateObj = { _id: boxDetails._id, registerationCreated: true };
      await updateBox(this.token, updateObj);
      await getEpikBoxData(this.token, boxDetails._id);
    }
    this.setState({ isLoading: false });
  };

  checkSecurityCode = async () => {
    const { activateBox } = this.state;
    if (activateBox) {
      this.setState({ modalStatus: false });
      await this.onActivateBox();
      this.setState({ activateBox: false });
    } else {
      this.setState({
        confirmModalStatus: true,
        bodyText:
          // eslint-disable-next-line max-len
          'Are you sure you want to change the firmware version? This operation will change the bahavior of the MyEPIK interface. This does not change the firmware operation on the EPIK Edge Device.',
        warningStatus: 'firwareChange',
      });
    }
  };

  firmSelectedType = e => {
    if (e.value === 'wd-v2') {
      this.setState({ modalStatus: true, toggleCheck: true });
    } else {
      this.setState({ modalStatus: true, toggleCheck: false });
    }
  };

  onApplyUpdate = async () => {
    this.setState({
      confirmModalStatus: true,
      bodyText:
        // eslint-disable-next-line max-len
        'Are you sure you want to apply firmware updates to the EPIK Edge Device? Doing so will cause disruption of service.',
      warningStatus: 'update',
    });
  };

  obiReboot = async deviceId => {
    this.setState({
      confirmModalStatus: true,
      bodyText:
        // eslint-disable-next-line max-len
        'Warning! Proceeding with rebooting the EPI will cause service disruption to any line configured on this port are you sure you want to continue?',
      warningStatus: 'rebootObi',
      deviceId,
    });
  };

  onConfirm = async () => {
    this.setState({
      isLoading: true,
      confirmModalStatus: false,
    });
    const {
      boxDetails,
      updateBox,
      applyUpdateEpikBox,
      rebootEpikBox,
      rebootObi,
      changeAction,
    } = this.props;
    const { toggleCheck, warningStatus, deviceId } = this.state;
    if (warningStatus === 'reboot') {
      const res = await rebootEpikBox(this.token, boxDetails._id);
      if (res) {
        // [Action]- Change
        changeAction('reboot epik box');
        addDeviceActivityNote({ boxID: boxDetails?._id, note: 'Soft Reboot Epik Box' });
      }
      // await this.getBoxData();
    } else if (warningStatus === 'update') {
      const res = await applyUpdateEpikBox(this.token, boxDetails._id);
      if (res) {
        // [Action]- Change
        changeAction('update epik box');
      }
      await this.getBoxData();
    } else if (warningStatus === 'rebootObi') {
      this.setState({
        confirmModalStatus: false,
      });
      const res = await rebootObi(this.token, deviceId);
      if (res) {
        // [Action]- Change
        changeAction('reboot obi');
      }
      await this.getBoxData();
    } else {
      const changedBox = {
        ...{
          _id: boxDetails._id,
          assignedTo: boxDetails.assignedTo,
        },
        myEpik: toggleCheck,
      };
      // eslint-disable-next-line no-unused-expressions
      toggleCheck ? (global.myEpik = 'Yes') : (global.myEpik = 'No');

      // reset bulk
      this.props.resetBulkBoxSession();
      const res = await updateBox(this.token, changedBox);
      if (res) {
        // [Action]- Change
        changeAction('firmware version changed');
        setTimeout(async () => {
          if (!toggleCheck) {
            await this.systemStatus();
          }
        }, 3000);
        await this.getBoxData();
      }
    }
    this.setState({ isLoading: false });
  };

  onDetailCheckPress = async type => {
    const { getUpDownSpeedInformation, boxDetails } = this.props;
    this.setState({
      isLoading: true,
    });
    if (type === '4g') {
      await this.speedBox();
    }
    if (type === 'voice') {
      const upDownSpeedInfo = await getUpDownSpeedInformation(boxDetails.serialNumber, type);
      this.setState({ speedTestInfo: upDownSpeedInfo.speedTestInfo });
    }
    if (type === 'data') {
      const upDownSpeedInfo = await getUpDownSpeedInformation(boxDetails.serialNumber, type);
      this.setState({ speedDataInfo: upDownSpeedInfo.speedTestInfo });
    }
    if (type === 'eth0' || type === 'wwan0' || type === 'wlan0') {
      await this.pingDevices(type);
    }
    if (type === 'fetcheth0') {
      await this.pingDevicesFetchResult('eth0');
    }
    if (type === 'fetchwwan0') {
      await this.pingDevicesFetchResult('wwan0');
    }
    if (type === 'fetchwlan0') {
      await this.pingDevicesFetchResult('wlan0');
    }
    this.setState({ isLoading: false });
  };

  filterLogs = value => {
    const { filterLogs } = this.props;
    filterLogs(value);
  };

  onIntegrated = async () => {
    const { user } = this.props;
    if (user.role === 'admin') {
      toast.error('You do not have permissions for this function.');
      return
    }
    // if (this.state.noActivation)
    //   return this.setState({
    //     integrateModalSecure: true
    //   });
    if (this.state.noActivation) {
      this.setState({
        tempModal: true,  // open the next modal directly without showing security modal
      });
      return;
    }
    const { boxDetails } = this.props;
    const portsActivatedArr = boxDetails?.Obis?.reduce((acc, obi) => {
      return [...acc, obi.port1, obi.port2];
    }, []);
    const filter = arrayType;
    const ports = portsActivatedArr?.filter(
      port => port?.assignedNumberRef?.type && filter.includes(port?.assignedNumberRef?.type),
    );
    const partialActivation = ports?.every(port => port.portActivated === true);

    const portsActivated = ports?.some(port => port?.portActivated === true);

    const isPriPortActivated = this.props?.priSettings?.portActivated;
    const isCasPortActivated = this.props?.sipSettings?.portActivated;

    if (portsActivated || boxDetails?.oobPortActivated || isPriPortActivated || isCasPortActivated) {
      const partialActivation = ports?.some(port => port.portActivated === false);
      if (partialActivation && !(boxDetails?.oobPortActivated || isPriPortActivated || isCasPortActivated)) {
        this.setState({
          partialWarning: true,
        });
      } else {
        this.setState({
          // integrateModalSecure: true
          tempModal: true,  // Directly proceed to the next modal for integration
        });
      }
    } else {
      toast.error('There are no ports ready for activation.');
    }
  };

  onConfirmIntegrated = () => {
    this.setState({
      integrateModalSecure: false,
      tempModal: true,
    });
  }
  onTempOption = e => {
    const { currentTarget } = e;
    this.setState({
      tempValue: currentTarget.value,
    });
  };

  onIntegrateSelect = e => {
    const { currentTarget } = e;
    this.setState({
      actionVal: currentTarget.value,
      controlExecuteBtn: currentTarget.value === 'cancel' ? false : true,
    });
  };

  onChangeBillingDate = e => {
    const { currentTarget } = e;
    this.setState({
      newBillingDate: currentTarget.value,
      controlExecuteBtn: currentTarget.value ? false : true,
    });
  };

  intergratedConfirm = async () => {
    const { actionVal } = this.state;

    if (actionVal === 'change') {
      this.setState({
        isLoading: false,
        changeIntegrate: true,
        tempModal: false,
      });
    } else {
      this.setState({
        isLoading: false,
        tempModal: false,
        cancelIntegrate: true,
      });
    }
  };

  onTempConfirm = async () => {
    const { boxDetails, convertBoxDid,user } = this.props;
    const { tempValue, actionVal } = this.state;
    const { Obis } = boxDetails;

    this.setState({
      isLoading: true,
      integrateModalSecure: false
    });
    if (actionVal === 'change') {
      this.intergratedConfirm();
    } 
    else if (actionVal === 'cancel') {
      await this.onCancelIntegrateConfirm();
    } else {
      if (tempValue === 'yes') {
        const numbersArray = [];
        Obis.forEach(item => {
          const { port1, port2 } = item;
          numbersArray.push(port1?.assignedNumberRef?._id, port2?.assignedNumberRef?._id);
        });
        const filteredNumbers = numbersArray?.filter(Boolean);
        const body = {
          numberIDs: filteredNumbers,
          permanent: tempValue,
        };
        await convertBoxDid(this.token, boxDetails._id, body);
      }

      this.updateEpikFields({
        integratedChange: true,
        integratedBy: this.props.user.email,
        _id: boxDetails._id,
        assignedTo: boxDetails.assignedTo,
      });
      this.setState({
        tempModal: false,
        isLoading: false,
      });
    }
  };

  onCancelIntegrateConfirm = async () => {
    const { boxDetails } = this.props;

    this.setState({
      isLoading: false,
      tempModal: false,
      changeIntegrate: false,
      cancelIntegrate: false,
    });

    this.updateEpikFields({
      integratedChange: false,
      integratedBy: this.props.user.email,
      _id: boxDetails._id,
      assignedTo: boxDetails.assignedTo,
    });

    this.setState({
      tempModal: false,
      isLoading: false,
      actionVal: '',
      controlExecuteBtn: true,
      cancelIntegrate: false,
    });
  };

  onChangeIntegrateConfirm = async () => {
    const { boxDetails } = this.props;
    const { newBillingDate } = this.state;

    this.setState({
      isLoading: true,
    });

    this.updateEpikFields({
      integratedChange: true,
      integratedBy: this.props.user.email,
      newIntegrateBillDate: newBillingDate,
      _id: boxDetails._id,
      assignedTo: boxDetails.assignedTo,
    });

    this.setState({
      tempModal: false,
      isLoading: false,
      actionVal: '',
      changeIntegrate: false,
      newBillingDate: '',
      controlExecuteBtn: true,
    });
  };

  onAnalyticsCall = async () => {
    const { boxDetails, getBoxVtelCdrs } = this.props;
    const { _id, serialNumber } = boxDetails;

    this.setState({
      cdrAnalytics: true,
      isLoading: true,
    });

    const boxCrds = await getBoxVtelCdrs(this.token, _id);

    this.setState({
      boxCdrs: boxCrds,
      isLoading: false,
    });
  };

  onCDRModalCancel = async () => {
    const { isActivityRowSelected } = this.state;
    if (isActivityRowSelected) {
      this.setState({ isActivityRowSelected: false });
    } else {
      this.setState({ cdrAnalytics: false, isActivityRowSelected: false });
    }
  };

  locationFilter = async location => {
    await this.props.getEpikBoxesDataByLocation(this.token, location._id, location.company);
    // this.setState({ locationSelect: true, selectedLocationId: location._id });
  };

  onMapIconClick = async () => {
    const { boxDetails, getEpikBoxesGeoLocation } = this.props;
    const { _id: boxId } = boxDetails;
    this.setState({ isLoading: true });
    const boxGeoCoordinates = await getEpikBoxesGeoLocation(this.token, boxId);
    console.log({ boxGeoCoordinates });
    if (boxGeoCoordinates && boxGeoCoordinates?.response) {
      this.setState({
        edgeDeviceGeoCoordinates: boxGeoCoordinates,
        displayEdgeDeviceLocator: true,
        isLoading: false,
      });
    }
    this.setState({
      isLoading: false,
    });
  };

  // Commenting this for future use
  /* openUpdateAddressModal = async () => {
    console.log('Open new modal');
    this.setState({
      updateEdgeDeviceLocator: true,
    });
  };

  updateDeviceGeoAddress = async () => {
    const { updateEstematedAddress } = this.state;
    console.log('updateDeviceGeoAddress...', updateEstematedAddress);
  };

  updatedEstAddress = values => {
    this.setState({ updateEstematedAddress: values });
  };
  */

  IntegrationButton = () => {
    const { boxDetails,user} = this.props;
    const portsActivatedArr = boxDetails?.Obis?.reduce((acc, obi) => {
      return [...acc, obi.port1, obi.port2];
    }, []);
    const filter = arrayType;
    const ports = portsActivatedArr?.filter(
      port => port?.assignedNumberRef?.type && filter.includes(port?.assignedNumberRef?.type),
    );
    const partialActivation = ports?.some(port => port.portActivated === false);
    const isPriPortActivated = this.props?.priSettings?.portActivated;
    const isCasPortActivated = this.props?.sipSettings?.portActivated;

    let buttonText = '';
    let style = {};
    if (boxDetails?.integrated) {
      if (partialActivation && !(boxDetails?.oobPortActivated || isPriPortActivated || isCasPortActivated)) {
        buttonText = 'Partial Integration';
        style = {
          color: '#000000',
          borderColor: '#FFC725',
          backgroundColor: '#FFC725',
        };
      } else {
        buttonText = 'Integrated';
        style = {
          color: '#666666',
          borderColor: '#cccccc',
          backgroundColor: '#cccccc',
        };
      }
    } else {
      buttonText = 'Integrate';
      style = { color: '#ffffff', backgroundColor: 'danger' };
    }
    return (
      (
        <Button
          className="activate-btn"
          hidden={boxDetails.isDemoBox}
          color={boxDetails?.integrated ? 'success' : 'danger'}
          style={style}
          onClick={this.onIntegrated}
        >
          {buttonText}
        </Button>
      )
    );
  };

  onDownloadNotes = async type => {
    const { notesSelectedTab, boxDetails, selectedNotesTabFilters, exportBoxNotes } = this.props;
    this.setState({
      isLoading: true,
    });

    const tabs = {
      1: 'allUsers',
      2: 'system',
    };

    const currentTabFilter = {
      ...selectedNotesTabFilters,
      type: tabs[notesSelectedTab],
      fileType: type,
      serialNumber: boxDetails.serialNumber,
    };

    await exportBoxNotes(this.token, boxDetails._id, currentTabFilter);

    this.setState({
      isLoading: false,
    });
  };

  onChangeEpiInput = e => {
    const { currentTarget } = e;
    this.setState({
      newMacAddress: currentTarget?.value,
    });
  };

  addNewMacAddress = async () => {
    const { newMacAddress } = this.state;
    const { addNewMacAddress } = this.props;

    const obiPrefix = '9CA';
    const escenePrefix = '002';
    const validMacAddress =
      newMacAddress?.startsWith(obiPrefix) || newMacAddress?.startsWith(escenePrefix);

    if (!validMacAddress) {
      toast.error(`Please enter a valid MAC address`);
      return;
    }

    this.setState({ isLoading: true });

    const epiResp = await addNewMacAddress(this.token, newMacAddress);

    if (!epiResp) this.setState({ isLoading: false });
    else this.setState({ isLoading: false, addNewEpi: false });
  };

  onConfirmEPIReboot = async () => {
    const { updateEpisFirmware, boxDetails, getEpikBoxData } = this.props;
    this.setState({ isLoading: true /*, epiFwUpdate: true*/ });

    await updateEpisFirmware(this.token, boxDetails._id, null);
    await getEpikBoxData(this.token, boxDetails._id);

    this.setState({ isLoading: false /*, epiFwUpdate: false */});
  };

  onActivateButtonPress = () => {

  }

  render() {
    const { state, props } = this;
    const { boxDetails, notesSelectedTab,user} = props;
    const { edgeDeviceGeoCoordinates } = state;
    const isESeries = boxDetails?.serialNumber && boxDetails?.serialNumber?.startsWith('E-')
    if (state.isLoading && !state.initialStatus) {
      return <Spinner />;
    }
    return (
      <div>

        {state.isLoading ? (
          <Spinner customText={state?.cdrAnalytics ? 'Please wait…' : ''} />
        ) : null
          /* (
            <WarningModal
              isOpen={lockBoxStatus && state.lockWarning}
              onCancel={() => this.setState({ lockWarning: false })}
              onConfirm={this.boxLockEnable}
            />
          ) */
        }

        {!state.isBoxOnline.value && !boxDetails?.serialNumber?.startsWith('E-') && (
          <Alert color="warning" className="d-flex align-items-center justify-content-center">
            <div>
              <strong>Warning:</strong> The box seems to be offline
            </div>
          </Alert>
        )}
        <Container fluid style={{ margin: 0 }}>
          <div className="viewContainer" style={{ padding: '20px', marginTop: '20px', position: 'relative' }}>
            <div className="box-header">
              {
              (props.user.role === 'superAdmin' || props.user.role === 'companyGroupAdmin')  && 
                <AdminFlagsDropDown 
                  engineeringLock={this.props.engineeringLock} 
                  isDemoBox={this.props.boxDetails?.isDemoBox} 
                  epikUpdateStatus={this.props.boxDetails?.epikUpdateStatus} 
                  boxId={this.props.boxDetails?._id} 
                />
              }
              <h6
                className="box-name-title"
                onClick={() => {
                  props.user.role === 'admin' ||
                    props.user.role === 'enterpriseAdmin' ||
                    props.user.role === 'companyGroupManager'
                    ? console.log('not permitted')
                    : !props.deleteMode
                      ? props.showUpdateEpikBox(props.boxDetails)
                      : console.log('delete mode');
                }}
              >
                <span hidden={props?.boxDetails?.enabled} style={{ color: 'red' }}>
                  SUSPENDED
                </span>{' '}
                {boxDetails?.assignedTo?.name} {' | '} {boxDetails?.displayName || ""}
              </h6>
              <div className="notes-box">
                {
                  utils.filterCustomer(props.user.role) ? (
                    <Button 
                      color="primary" 
                      style={{ margin: '0 100px 10px 0' }}
                      onClick={() => {
                        props.getEpikBoxesByFavorites(this.token, null);
                        props.showUpdateEpikBox(props.boxDetails);
                      }}
                    >
                      View Device Details
                    </Button>
                  ) : null
                }
                {!isESeries && props.boxDetails.integrated && (
                  <p style={{ marginRight: 10, marginTop: 10 }}>
                    {utils.getDateTimeFormat(props.boxDetails.dateIntegrated, 'both')}
                  </p>
                )}
                {/* {
                  !isESeries ? 
                    isAdminRole(props.user.role) ? <> </> : state.noActivation ? (
                      <Button
                        className="activate-btn"
                        color={props?.boxDetails?.integrated ? 'success' : 'danger'}
                        style={
                          props?.boxDetails?.integrated
                            ? { color: '#666666', borderColor: '#cccccc', backgroundColor: '#cccccc' }
                            : { color: '#ffffff', backgroundColor: 'danger' }
                        }
                        onClick={this.onIntegrated}
                      >
                        {props.boxDetails.integrated ? 'Integrated' : 'Integrate'}
                      </Button>
                    ) : (
                      this.IntegrationButton()
                    ) : null
                } */}
                {
                  !isESeries ?
                    isAdminRole(props.user.role) ?
                      <> </> :
                      (state.noActivation && this.state.cancelIntegrationAccess) ? ( // Check if cancelIntegration is true
                        <Button
                          className="activate-btn"
                          color={props?.boxDetails?.integrated ? 'success' : 'danger'}
                          style={
                            props?.boxDetails?.integrated
                              ? { color: '#666666', borderColor: '#cccccc', backgroundColor: '#cccccc' }
                              : { color: '#ffffff', backgroundColor: 'danger' }
                          }
                          onClick={this.onIntegrated}
                          disabled={!(this.state.cancelIntegrationAccess === 'write' || this.state.cancelIntegrationAccess === 'both')}
                        >
                          {props.boxDetails.integrated ? 'Integrated' : 'Integrate'}
                        </Button>
                      ) : (
                        (this.state.cancelIntegrationAccess === 'write' || this.state.cancelIntegrationAccess === 'both') && 
                        this.IntegrationButton()
                      )
                    : null
                }
                {
                  !isESeries && <ActivateButton onClick={() => {
                    this.setState({ modalStatus: true, activateBox: true })
                  }}
                  />
                }
                {/* it is temporary disabled feature */}
                {/* <FontAwesomeIcon
                  icon="map-marked-alt"
                  size="lg"
                  color="#3b5aa9"
                  onClick={this.onMapIconClick}
                  className="map-list-icon"
                /> */}

                {/* Hidding logs button on purpose */}
                <div
                  hidden={true}
                  onClick={() => this.onLogsPress()}
                  style={{ marginBottom: '15px' }}
                >
                  <img className="actions-icon" src={logIcon} alt="..." />
                </div>
                <h6>Notes:</h6>
                <div onClick={() => this.onNotesPress()} style={{ marginBottom: '15px' }}>
                  <img className="actions-icon" src={notesIcon} alt="..." id="list_notes" />
                </div>
              </div>
            </div>
            <div className="row">
              {!!props.boxDetails?._id && <BoxHeader isBoxOnline={this.state.isBoxOnline} />}
            </div>
            {/* {!this.state.isLoading && ( */}
            <RebootEPINotification boxDetails={props.boxDetails} obiReboot={this.obiReboot} />
            {/* )} */}
            <div className="row">
              <BoxPortingDetails
                handlePhoneDelete={this.handlePhoneDelete}
                updatePhoneStatus={this.updatePhoneStatus}
                lockStatus={this.lockStatus}
                getBoxData={this.getBoxData}
                state={this.state}
                setState={e => this.setState(e)}
                boxLockEnable={this.boxLockEnable}
                onBoxContainerClick={this.onBoxContainerClick}
                obiReboot={this.obiReboot}
                onApplyUpdate={this.onApplyUpdate}
                updateEpikFields={this.updateEpikFields}
                boxTrigger={this.boxTrigger}
                getAdminFlags={this.props.getAdminFlags}
              />
              {
                !isESeries && 
                <Col md={6}>
                  <InfoToolTab
                    boxDetails={props.boxDetails}
                    onDetailBtn={this.onDetailCheckPress}
                    speedTestInfo={state.speedTestInfo}
                    speedDataInfo={state.speedDataInfo}
                    onApplyUpdate={this.onApplyUpdate}
                    fwdv2={state.fwdv2}
                    onReloadBox={this.getBoxData}
                  />
                </Col>
              }
            </div>
            {props.boxToUpdate ? (
              <UpdateEpikBoxModal
                firmSelectedType={this.firmSelectedType}
                enableBoxEdit={state.enableBoxEdit}
                isOpen={props.updateBoxOpen}
                onConfirm={this.updateEpikFields}
                onCancel={props.cancelUpdateEpikBox}
                box={props.boxToUpdate}
                user={props.user}
                getBoxData={this.getBoxData}
              />
            ) : null}
            <AddPhone
              phone={props.phone}
              data={state.phoneFormData}
              isOpen={props.showPhone}
              onCancel={props.hidePhoneModal}
              onConfirm={this.insertPhone}
              showNumberModal={this.handleNumberModal}
            />
            <EditPhoneNumber
              phone={this.phoneObj}
              isOpen={props.showNumber}
              onCancel={() => {
                this.updateNumberCall = false;
                props.hideNumberModal();
              }}
              onConfirm={() => {
                this.updateNumberCall = true;
                props.hideNumberModal();
              }}
            />
            <DeleteBoxPhoneModal
              title={'Delete Phone?'}
              body={'Do you really want to delete the Phone?'}
              onConfirm={this.onDeleteBoxPhoneConfirm}
              onCancel={props.cancelDeletePhone}
              isOpen={props.deletePhoneOpen}
            />
            <AddNotesList
              onEditNote={this.onEditNote}
              onDownload={this.downloadAttachment}
              onDeleteNote={this.onDeleteNote}
              onDeleteNoteRecording={this.onDeleteNoteRecording}
              user={props.user}
              handleChangePagination={this.handleNotesPagination}
              isOpen={state.showNotes}
              onConfirm={this.addNotes}
              onCancel={() => {
                this.setState({ showNotes: false });
              }}
              boxNotes={props.boxNotes}
              boxDetails={props.boxDetails}
              onDownloadNotes={this.onDownloadNotes}
              notesSelectedTab={notesSelectedTab}
            />
            <LogsModal
              filterLogs={this.filterLogs}
              boxDetails={props.boxDetails}
              boxLogs={props.boxLogs}
              isOpen={state.logModalStatus}
              onCancel={() => {
                this.setState({ logModalStatus: false });
              }}
            />
            <UnAssignedObiModal
              showUnassignedObi={props.showUnassignedObi}
              unassignedLoading={props.unassignedLoading}
              onAssignObi={this.onAssignObi}
              populateEpis={() => props.populateEpis(this.token)}
              closeUnassignedObis={props.closeUnassignedObis}
              user={props?.user}
              onAddEpi={() => {
                this.setState({ addNewEpi: true });
              }}
            />
            {this.renderSelectedInfoModal()}
            <ConfigModal
              showBoxConfigModal={props.showBoxConfigModal}
              obis={props.boxDetails.Obis}
              confSelectedObi={state.confSelectedObi}
              downloadConfig={this.downloadConfig}
              download={download}
              hideBoxConfig={props.hideBoxConfig}
              setConfSelectedObi={suggestion => this.setState({ confSelectedObi: suggestion })}
              setJsonConfig={ev => this.jsonConfig(ev)}
            />
          </div>
        </Container>
        <AddSecurityCodeModal
          isOpen={state.modalStatus}
          onCancel={() => {
            this.setState({ modalStatus: false, activateBox: false });
          }}
          onConfirm={this.checkSecurityCode}
          multiCode={state.activateBox}
          // modalName={state.activateBox?'box activation':'firmware update'}
          featureName={state.activateBox ? 'boxActivation' : 'firmwareUpdate'}
        />
        <AddSecurityCodeModal
          isOpen={state?.cancelIntegrate}
          onCancel={() => {
            this.setState({ changeIntegrate: false, cancelIntegrate: false });
          }}
          onConfirm={this.onCancelIntegrateConfirm}
          cancelIntegrate={state?.cancelIntegrate}
          // modalName='cancelIntegration'
          featureName='cancelIntegrate'
        />
        <AddSecurityCodeModal
          isOpen={state.integrateModalSecure}
          onCancel={() => {
            this.setState({ integrateModalSecure: false });
          }}
          onConfirm={this.onConfirmIntegrated}
          integratedPort
          featureName='integratedPort'
        />
        <CustomModal
          header="Edge Device Locator"
          isOpen={state.displayEdgeDeviceLocator}
          onCancel={() => this.setState({ displayEdgeDeviceLocator: false })}
          // onConfirm={this.openUpdateAddressModal} // commented this for future use
          // confirmDisabled={edgeDeviceGeoCoordinates?.status !== 200} // commented this for future use
          close
        // confirmBtnText="Update Address" // commented this for future use
        >
          {edgeDeviceGeoCoordinates?.status === 202 ? (
            <span>{edgeDeviceGeoCoordinates?.response}</span>
          ) : (
            <>
              <p>
                <strong>Coordinates: </strong>
                {edgeDeviceGeoCoordinates?.response}
              </p>
              <p>
                <strong>Estimated Address: </strong>
                {edgeDeviceGeoCoordinates?.estimatedAddress?.results.length
                  ? edgeDeviceGeoCoordinates?.estimatedAddress?.results[0]?.formatted_address
                  : edgeDeviceGeoCoordinates?.estimatedAddress?.plus_code?.compound_code}
              </p>
              <EdgeDeviceLocator coordinates={edgeDeviceGeoCoordinates?.response} />
            </>
          )}
        </CustomModal>

        {/* Commenting this out for future use. We don't need this for now. */}
        {/* <CustomModal
          header="Update Address"
          isOpen={state.updateEdgeDeviceLocator}
          onCancel={() => this.setState({ updateEdgeDeviceLocator: false })}
          onConfirm={this.updateDeviceGeoAddress}
          confirmDisabled={edgeDeviceGeoCoordinates?.status !== 200}
          close
          confirmBtnText="Update"
        >
          <UpdateBoxLocation
            currentLocation={boxDetails?.locRef}
            newLocation={edgeDeviceGeoCoordinates?.estimatedAddress}
            updatedEstAddress={this.updatedEstAddress}
          />
        </CustomModal> */}
        <ConfirmationModal
          isOpen={state.confirmModalStatus}
          onCancel={() => {
            this.setState({ confirmModalStatus: false });
          }}
          bodyText={state.bodyText}
          onConfirm={this.onConfirm}
        />
        {/* <ConfirmationModal
          isOpen={state.epiFwUpdate}
          onCancel={() => {
            this.setState({ epiFwUpdate: false });
          }}
          headerText={`EPI Firmware Update Required`}
          bodyText={`There is a firmware update required on the EPI's on the device. This process will take approximately 15 minutes to complete and require the ports on this device to reboot. Would you like to proceed with this update now?`}
          onConfirm={this.onConfirmEPIReboot}
        /> */}
        <ConfirmationModal
          bodyText={
            state?.alerEngineerLock
              ? `The Device has custom configurations set by EPIK Engineering and is locked for editing and changes. Please contact EPIK Engineering if changes or troubleshooting is needed for this device.`
              : `This action will change the Bill start date from ${moment(
                props.boxDetails.dateIntegrated,
              ).format('L')} to ${moment(state.newBillingDate).format('L')}`
          }
          isOpen={(state?.alerEngineerLock && props?.boxDetails?._id === state?.alerEngineerLock['box']) || state?.changeIntegrate}
          onConfirm={this.onChangeIntegrateConfirm}
          onCancel={() =>
            this.setState({
              alerEngineerLock: false,
              changeIntegrate: false,
              newBillingDate: '',
              actionVal: '',
            })
          }
          confirmBtnText="Yes"
          ignoreConfirmButton={!state?.changeIntegrate}
        />
        <CdrAnalyticsModal
          headText={
            !state?.isActivityRowSelected ? `Real Time Port Activityssss` : `CDR Log Analysis`
          }
          isOpen={state?.cdrAnalytics}
          cdrs={state?.boxCdrs}
          isCdrLogs={!!state?.isActivityRowSelected}
          cdrVoipMonLogs={state?.boxActivityLogs}
          onCancel={this.onCDRModalCancel}
        />
        <CustomWarning
          disabled={props?.boxDetails?.integrated ? state?.controlExecuteBtn : false}
          isOpen={state.tempModal}
          onCancel={() => this.setState({ tempModal: false, newBillingDate: '', actionVal: '', integrateModalSecure: false })}
          onConfirm={this.onTempConfirm}
          bodyText={
            props?.boxDetails?.integrated
              ? ''
              : `Attention! This will initiate customer billing for all ${state.noActivation ? 'provisioned' : 'activated'
              } ports. Are you ready to proceed?`
          }
          boldText={props?.boxDetails?.integrated ? null : 'Attention!'}
          isIntegratedBox={props?.boxDetails?.integrated}
        >
          {props?.boxDetails?.integrated ? (
            <>
              <p className="text-style">
                Service integrated on{' '}
                {
                  utils.getDateTimeFormat(props?.boxDetails?.dateIntegrated, 'regular')
                } at{' '}
                {utils.getDateTimeFormat(props?.boxDetails?.dateIntegrated, 'time')} by user{' '}
                {props?.boxDetails?.integratedBy}
              </p>
              <Row style={{ marginBottom: '10px' }}>
                <Col md={5} sm={12}>
                  <h1>Actions</h1>
                </Col>
                <Col md={7}>
                  <select
                    className="form-control"
                    name="integrated-service"
                    value={state.actionVal}
                    onChange={this.onIntegrateSelect}
                  >
                    <option value="">Select Any</option>
                    <option value="change">Change Integration</option>
                    <option value="cancel">Cancel Integration</option>
                  </select>
                </Col>
              </Row>

              {state?.actionVal === 'change' ? (
                <Row>
                  <Col md={5} sm={12}>
                    <h1>Enter New Billing Start Date</h1>
                  </Col>
                  <Col md={7}>
                    <Input
                      placeholder="Please specify"
                      required
                      type="date"
                      name="fromDate"
                      value={state?.newBillingDate}
                      onChange={this.onChangeBillingDate}
                    />
                  </Col>
                </Row>
              ) : state?.actionVal === 'cancel' ? (
                <p className="warning cancel" style={{ color: '#de4659' }}>
                  <strong>
                    WARNING! Canceling integration will wipe the current provisioning off ports and impact customer billing. Are you sure you want to continue?
                  </strong>
                </p>
              ) : (
                ''
              )}
            </>
          ) : (
            <Row>
              <Col md={6} sm={12}>
                <p>Convert Temp DIDs to permanent:</p>
              </Col>
              <Col md={4} sm={12}>
                <CustomSelection
                  name="filter"
                  value={state?.tempValue}
                  onChange={this.onTempOption}
                  optionsList={filterOptions}
                />
              </Col>
            </Row>
          )}
        </CustomWarning>
        <CustomWarning
          isOpen={state.partialWarning}
          onCancel={() => this.setState({ partialWarning: false })}
          onConfirm={() => {
            this.setState({
              tempModal: true,
              partialWarning: false,
            });
          }}
        >
          There are ports that have not yet been activated. Would you like to proceed with Partial
          Integration?
        </CustomWarning>
        <CustomModal
          header="Add New EPI"
          isOpen={state?.addNewEpi}
          onCancel={() => this.setState({ addNewEpi: false })}
          onConfirm={this.addNewMacAddress}
          close
          confirmBtnText="Add EPI"
        >
          <Row>
            <Col md={4} sm={12}>
              <h1 style={{ lineHeight: 2, marginBottom: 'auto' }}>Enter New Mac Address</h1>
            </Col>
            <Col md={8}>
              <Input
                placeholder="Please specify"
                required
                type="text"
                name="newEPI"
                onChange={this.onChangeEpiInput}
              />
            </Col>
          </Row>
        </CustomModal>
        <PingModal 
          isOpen={state?.isModalOpen} 
          onCancel={() => this.handlePingClose()} 
          data={state?.fetchPingData} 
          pingheading={`Ping From ${state?.pingType}`} 
          user={props?.user}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.AppState.user,
    companies: state.AppState.companies,
    unassignedObis: state.AppState.obis.unassignedObis,
    boxDetails: state.AppState.boxDetails.box,
    systemStatus: state.AppState.boxDetails.systemStatus,
    editedNumber: state.UIState.numbers.editNumber,
    boxToActivate: state.UIState.epikBoxes.boxToActivate,
    updateBoxOpen: state.UIState.epikBoxes.updateBoxOpen,
    selectedObi: state.UIState.epikBoxDetails.selectedObi,
    selectedPort: state.UIState.epikBoxDetails.selectedPort,
    selectAta: state.UIState.epikBoxDetails.selectAta,
    showUnassignedObi: state.UIState.epikBoxDetails.showUnassignedObi,
    showBoxConfigModal: state.UIState.epikBoxDetails.showBoxConfigModal,
    unassignedLoading: state.UIState.obis.unassignedLoading,
    portConfigChangesMade: state.UIState.epikBoxDetails.portConfigChangesMade,
    boxToUpdate: state.UIState.epikBoxes.boxToUpdate,
    deleteMode: state.AppState.deleteMode,
    showPhone: state.UIState.epikBoxes.showPhoneModal,
    hidePhone: state.UIState.epikBoxes.hidePhoneModal,
    showNumber: state.UIState.epikBoxes.showNumberModal,
    hideNumber: state.UIState.epikBoxes.hideNumberModal,
    masterBoxPress: state.UIState.users.masterBoxPress,
    phone: state.AppState.phone,
    deletePhoneOpen: state.AppState.phone.deletePhoneModal,
    addedNumber: state.UIState.numbers.addNumber,
    priResBox: state.AppState.obis.priResBox,
    boxNotes: state.AppState.boxNotes,
    securityCode: state.UIState.users.addedUser.security,
    boxLogs: state.AppState.boxLogs,
    lockStatusBox: state.UIState.epikBoxes.lockStatusEpikBox,
    engineeringLock: state.AppState.boxDetails.engineeringLock,
    editModifyStatus: state.UIState.obis.modifyEditStatus,
    numberByID: state.AppState.numbers.numberByID,
    boxCdrActivity: state.AppState.boxDetails.boxCdrActivity,
    selectedModalPortType: state.UIState.epikBoxes.selectedModalPortType,
    notesSelectedTab: state.UIState.epikBoxes.notesSelectedTab,
    selectedNotesTabFilters: state.UIState.epikBoxes.selectedNotesTabFilters,
    signalStrength: state.AppState.boxDetails.signalStrength,
    routeInfo: state.AppState.provisioning.routeInfo,
    selectedPortConfigTemplate: state.UIState.epikBoxDetails.selectedPortConfigTemplate,
    portConfigTemplates: state.UIState.epikBoxDetails.portConfigTemplates,
    priSettings: state.AppState.priSipData?.priSettingData,
    sipSettings: state.AppState.priSipData?.sipSettingData,
    suggectedCompany: state.AppState.boxDetails
  };
};

const mapDispatchToProps = dispatch => ({
  getSipPri: (token, bid, ispri) => dispatch(BoxesActions.getSipPri(token, bid, ispri)),
  fetchDataCenterLatency: (boxId, flag) =>
    dispatch(BoxesActions.fetchDataCenterLatency(boxId, flag)),
  getAlarmTest: (token, bid) => dispatch(BoxesActions.getAlarmTest(token, bid)),
  InitiateAlarm: timer => dispatch(BoxesActions.InitiateAlarm(timer)),
  resetDataCenterLatency: () => dispatch(BoxesActions.resetDataCenterLatency()),
  cancelDeletePhone: () => dispatch(BoxesActions.cancelDeletePhone()),
  deleteEpikBoxEpi: (token, obi) => dispatch(BoxesActions.deleteEpikBoxEpi(token, obi)),
  getEpikBoxData: (token, boxId) => dispatch(BoxesActions.getEpikBoxData(token, boxId)),
  getSignalStrength: (token, boxId) => dispatch(BoxesActions.getSignalStrength(token, boxId)),
  getBoxPower: (token, boxId) => dispatch(BoxesActions.getBoxPower(token, boxId)),
  getRestStatus: (token, boxId) => dispatch(BoxesActions.getRestStatus(token, boxId)),
  getBoxCarrier: (token, boxId) => dispatch(BoxesActions.getBoxCarrier(token, boxId)),
  getEngineeringLock: (token, boxId) => dispatch(BoxesActions.getEngineeringLock(token, boxId)),
  getSystemStatus: (token, boxId) => dispatch(BoxesActions.getSystemStatus(token, boxId)),
  getUnassignedObis: (token, searchString) =>
    dispatch(BoxesActions.getUnassignedObis(token, searchString)),
  assignObi: (token, obi, box, company) =>
    dispatch(BoxesActions.assignObiToBox(token, obi, box, company)),
  updateBox: (token, box) => dispatch(BoxesActions.updateEpikBox(token, box)),
  activateEpikBox: (token, bid) => dispatch(BoxesActions.activateEpikBox(token, bid)),
  rebootEpikBox: (token, bid) => dispatch(BoxesActions.rebootEpikBox(token, bid)),
  applyUpdateEpikBox: (token, bid) => dispatch(BoxesActions.applyUpdateEpikBox(token, bid)),
  convertBoxDid: (token, bid, body) => dispatch(BoxesActions.convertBoxDid(token, bid, body)),
  updateObi: (token, obi, epikBoxUser, numId) =>
    dispatch(BoxesActions.updateEpikBoxObi(token, obi, epikBoxUser, numId)),
  updateNumbers: (token, obi, epikBoxUser, numId,fieldToUpdate, value, showToast) =>
    dispatch(BoxesActions.updateNumbers(token, obi, epikBoxUser, numId,fieldToUpdate, value, showToast)),
  advancedMonitoring: (token, body) => dispatch(BoxesActions.advancedMonitoring(token, body)),
  unassignNumber: (token, numId, port) => dispatch(BoxesActions.unassignNumber(token, numId, port)),
  uploadPortConfig: (token, obi, file) => dispatch(BoxesActions.uploadPortConfig(token, obi, file)),
  postOBIConfig: (token, obi, jsonObj) => dispatch(BoxesActions.postBoxConfig(token, obi, jsonObj)),
  downloadOBIConfig: (token, obi) => dispatch(BoxesActions.downloadBoxConfig(token, obi)),
  populateEpis: token => dispatch(BoxesActions.populateEpis(token)),
  clearSelectedObi: () => dispatch(BoxesActions.clearBoxDetailsObi()),
  selectPort: port => dispatch(BoxesActions.selectBoxDetailsPort(port)),
  selectObi: obi => dispatch(BoxesActions.selectBoxDetailsObi(obi)),
  selectExternalAta: ata => dispatch(BoxesActions.selectBoxDetailsAta(ata)),
  clearSelectedPort: () => dispatch(BoxesActions.clearBoxDetailsPort()),
  clearBoxDetailsAtaPort: () => dispatch(BoxesActions.clearBoxDetailsAtaPort()),
  clearPortConfigChangesMade: () => dispatch(BoxesActions.clearPortConfigChangesMade()),
  clearPortConfigModalSource: () => dispatch(BoxesActions.clearPortConfigModalSource()),
  closeUnassignedObis: () => dispatch(BoxesActions.closeUnassignedObis()),
  showBoxConfig: () => dispatch(BoxesActions.openBoxConfig()),
  hideBoxConfig: () => dispatch(BoxesActions.closeBoxConfig()),
  cancelRearrangeEPIs: () => dispatch(BoxesActions.cancelRearrangeEPIs()),
  configurePort: (token, box) => dispatch(BoxesActions.configurePort(token, box)),
  cancelUpdateEpikBox: box => dispatch(BoxesActions.cancelUpdateEpikBox(box)),
  showUpdateEpikBox: box => dispatch(BoxesActions.showUpdateEpikBox(box)),
  showPhoneModal: () => dispatch(BoxesActions.showPhoneModal()),
  hidePhoneModal: () => dispatch(BoxesActions.hidePhoneModal()),
  showNumberModal: () => dispatch(BoxesActions.showNumberModal()),
  hideNumberModal: () => dispatch(BoxesActions.hideNumberModal()),
  getNumbers: (token, companyId) => dispatch(BoxesActions.getNumbers(token, companyId)),
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(BoxesActions.getAssignedNumbers(token, cid, uid, priStatus)),
  insertPhone: (token, boxId, obj) => dispatch(BoxesActions.insertPhone(token, boxId, obj)),
  updatePhone: (token, phoneId, obj) => dispatch(BoxesActions.updatePhone(token, phoneId, obj)),
  deletePhone: (token, phoneId) => dispatch(BoxesActions.deletePhone(token, phoneId)),
  editNumber: (token, number, pagination, filter, type) =>
    dispatch(updateNumber(token, number, pagination, filter, type)),
  unassignAction: description => dispatch(unassignAction(description)),
  disableAction: description => dispatch(disableAction(description)),
  updateObiByNumber: (token, obiNumber, body) =>
    dispatch(updateObiByNumber(token, obiNumber, body)),
  updateAtaByNumber: (token, ataNumber, body) =>
    dispatch(updateAtaByNumber(token, ataNumber, body)),
  updateAtaByPortId: (token, ataId, body, epikBoxUser, numId) =>
    dispatch(updateAtaByPortId(token, ataId, body, epikBoxUser, numId)),
  addNewNumber: (token, id, number, pagination, filter, type) =>
    dispatch(addNumber(token, id, number, pagination, filter, type)),
  updateNumberRoute: (token, numId, body) => dispatch(updateNumberRoute(token, numId, body)),
  getForwardUri: (token, boxName, portName, name, externalAta) =>
    dispatch(getForwardUri(token, boxName, portName, name, externalAta)),
  addNumberFieldChange: (name, value) => dispatch(addNumberFieldChange(name, value)),
  getEpikBoxesData: (token, companyId, online, unmonitored) =>
    dispatch(BoxesActions.getEpikBoxesData(token, companyId, online, unmonitored)),
  addStep: step => dispatch(addStep(step)),
  popStep: () => dispatch(popStep()),
  masterBoxPressCall: status => dispatch(masterBoxPressCall(status)),
  unCheckPri: (token, bid) => dispatch(BoxesActions.unCheckPri(token, bid)),
  getNotes: (token, id, pagination) => dispatch(BoxesActions.getNotes(token, id, pagination)),
  getLogs: (token, id) => dispatch(BoxesActions.getLogs(token, id)),
  filterLogs: value => dispatch(BoxesActions.filterLogs(value)),
  downloadAttachment: (token, noteId, fileName, noDownload) =>
    dispatch(BoxesActions.downloadAttachment(token, noteId, fileName, noDownload)),
  deleteNote: (token, boxId, noteId) => dispatch(BoxesActions.deleteNote(token, boxId, noteId)),
  deleteNoteRecording: (token, noteId) => dispatch(BoxesActions.onDeleteRecording(token, noteId)),
  showDeletePhone: () => dispatch(BoxesActions.showDeletePhone()),
  addNote: (token, id, note) => dispatch(BoxesActions.addNote(token, id, note)),
  editNote: (token, boxId, note, noteId) =>
    dispatch(BoxesActions.editNote(token, boxId, note, noteId)),
  getCompanyNumbers: (token, pagination, id, type, disablePaginate) =>
    dispatch(getCompanyNumbers(token, pagination, id, type, disablePaginate)),
  getUpDownSpeedInformation: (serialNumber, type) =>
    dispatch(BoxesActions.getUpDownSpeedInformation(serialNumber, type)),
  getSpeedTestInformation: serialNumber =>
    dispatch(BoxesActions.getSpeedTestInformation(serialNumber)),
  getLteAnalyzer: (token, bid, vpnAddress) =>
    dispatch(BoxesActions.getLteAnalyzer(token, bid, vpnAddress)),
  rebootObi: (token, deviceId) => dispatch(BoxesActions.rebootObi(token, deviceId)),
  obiRebootRequired: (token, id, payload) =>
    dispatch(BoxesActions.obiRebootRequired(token, id, payload)),
  changeBulkBoxSession: (description, key) => dispatch(changeBulkBoxSession(description, key)),
  addAction: description => dispatch(addAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  deleteAction: description => dispatch(deleteAction(description)),
  changeAction: description => dispatch(changeAction(description)),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
  resetBulkBoxSession: () => dispatch(resetBulkBoxSession()),
  boxLockStatus: (token, bid) => dispatch(BoxesActions.boxLockStatus(token, bid)),
  boxLock: (token, bid) => dispatch(BoxesActions.boxLock(token, bid)),
  addBoxAction: (token, bid, body) => dispatch(BoxesActions.addBoxAction(token, bid, body)),
  eSIMStatus: (token, bid) => dispatch(BoxesActions.eSIMStatus(token, bid)),
  getBoxVtelCdrs: (token, bid) => dispatch(BoxesActions.getBoxVtelCdrs(token, bid)),
  updateNumberRouteAndTrunk: (token, bid) =>
    dispatch(BoxesActions.updateNumberRouteAndTrunk(token, bid)),
  getEpikBoxesGeoLocation: (token, bid) =>
    dispatch(BoxesActions.getEpikBoxesGeoLocation(token, bid)),
  checkNumberRouteAndTrunk: (token, bid) =>
    dispatch(BoxesActions.checkNumberRouteAndTrunk(token, bid)),
  exportBoxNotes: (token, bid, queryFilter) =>
    dispatch(BoxesActions.exportBoxNotes(token, bid, queryFilter)),
  addNewMacAddress: (token, macAddress) =>
    dispatch(BoxesActions.addNewMacAddress(token, macAddress)),
  end2FASession: (token, params) =>
    dispatch(BoxesActions.end2FASession(token, params)),
  getDataOnBoxLoad: (token, boxID) => dispatch(BoxesActions.getDataOnBoxLoad(token, boxID)),
  getIsBoxOnline: (token, boxID) => dispatch(BoxesActions.getIsBoxOnline(token, boxID)),
  setBoxDetailsData: (token, box) => dispatch(BoxesActions.setBoxDetailsData(token, box)),
  getActiveInterface: (token, boxID, vpnAddress) => dispatch(BoxesActions.getActiveInterface(token, boxID, vpnAddress)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
  getBoxVoltage: (token, vpnAddress) => dispatch(BoxesActions.getBoxVoltage(token, vpnAddress)),
  updateEpisFirmware: (token, boxID, macAddress) => dispatch(BoxesActions.updateEpisFirmware(token, boxID, macAddress)),
  getInitiatePing: (token, vpnAddress, type) => dispatch(BoxesActions.getInitiatePing(token, vpnAddress, type)),
  getFetchPingResult: (token, vpnAddress, type) => dispatch(BoxesActions.getFetchPingResult(token, vpnAddress, type)),
  getPriBoxesByCompany: (token, companyId) => dispatch(getPriBoxesByCompany(token, companyId)),
  getSipBoxesByCompany: (token, companyId) => dispatch(getSipBoxesByCompany(token, companyId)),
  getEpikBoxesByFavorites: filter => dispatch(BoxesActions.getEpikBoxesByFavorites(filter)),
  getAdminFlags: (token, boxId) => dispatch(BoxesActions.getAdminFlags(token, boxId)),
  getObiCallerOverRide: (token, bid,selectedNumber,overrideFlag)  => dispatch(getObiCallerOverRide(token, bid,selectedNumber,overrideFlag)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(EpikBoxDetails));
